<template>
  <div class="page-loading">
    <svg
      style="top: 0; left: 0; position: absolute"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1440 320"
    >
      <path
        fill="#ffd700"
        fill-opacity="1"
        d="M0,192L80,186.7C160,181,320,171,480,149.3C640,128,800,96,960,90.7C1120,85,1280,107,1360,117.3L1440,128L1440,0L1360,0C1280,0,1120,0,960,0C800,0,640,0,480,0C320,0,160,0,80,0L0,0Z"
      ></path>
    </svg>
    <!-- <svg width="100%" class="loading-logo" height="100%" viewBox="0 0 596 842">
      <g id="Layer_1">
        <g id="Group">
          <g id="Group_2">
            <g id="ur">
              <path
                d="M206.55 566.15C206.55 566.15 240.32 546.38 241.89 518.55C243 498.83 231.28 487.39 231.28 487.39C231.28 487.39 238.67 491.18 239.31 490.58C239.86 490.06 225.57 472.16 221.84 467.5C221.45 467.01 220.68 467.14 220.46 467.73L216.52 478.24C216.38 478.62 216.37 479.04 216.5 479.42C216.91 480.58 217.85 483.11 218.68 484C219.78 485.17 222.51 494.62 225.16 498.39C228.68 503.4 235.9 516.89 236.42 518.47C236.94 520.05 229.19 534.35 204.36 549.99C204.35 549.99 204.33 563.81 206.55 566.15Z"
                fill="#58595B"
              />
              <path
                d="M197.64 554.84C165.63 576.96 111 595.49 111 595.49C117.68 596.56 143.47 596.92 155.59 593.54C167.71 590.16 197.41 572.21 197.41 572.21C196.67 568.88 197.64 554.84 197.64 554.84Z"
                fill="#58595B"
              />
            </g>

            <g id="no">
              <path
                d="M277.32 525.835C286.39 526.125 297.31 521.755 297.31 521.755C297.31 521.755 299.03 524.175 297.04 530.065L290.58 540.805C290.58 540.805 284.1 558.735 284.56 564.805C284.56 564.805 306 544.925 305.02 516.905C305.02 516.905 317.53 507.145 319.58 492.045C321.63 476.945 320.32 478.035 319.3 474.455C318.28 470.875 312.46 462.465 312.17 460.395L319.79 463.575C320.73 463.965 321.59 462.885 321 462.055L306.2 441.305C305.79 440.735 304.91 440.845 304.66 441.505L299.93 453.945C299.54 454.975 299.98 456.135 300.95 456.645L302.31 457.365C302.31 457.365 301.43 461.115 305.22 469.565C309.01 478.005 315.27 488.895 315.22 490.495C315.17 492.105 310.97 499.145 302.99 503.235C302.99 503.235 294.77 485.575 281.24 486.075C267.7 486.585 264.69 503.785 264.52 508.975C264.35 514.165 262.21 525.335 277.32 525.835ZM278.49 501.475C286.39 501.165 290.95 507.695 290.95 507.695C290.95 507.695 276.57 513.045 269.31 507.485C269.31 507.495 270.6 501.785 278.49 501.475Z"
                fill="#58595B"
              />
              <path
                d="M221.46 579.035C195.85 577.355 203.32 539.585 203.32 539.585L201.74 540.245C201.74 540.245 189.64 593.905 223.63 595.265C251.95 596.405 273.53 575.275 273.53 575.275C273.53 575.275 273.65 566.555 277.32 555.025C277.31 555.035 254.05 581.175 221.46 579.035Z"
                fill="#58595B"
              />
              <path
                d="M265.89 442.305L280.09 448.555C281.17 449.035 282.44 448.585 282.98 447.525L288.19 437.345C288.67 436.405 288.24 435.255 287.26 434.865L273.35 429.255C272.49 428.905 271.51 429.235 271.03 430.015L265.06 439.635C264.47 440.595 264.86 441.855 265.89 442.305Z"
                fill="#58595B"
              />
            </g>

            <g id="elem">
              <path
                d="M393.45 417.205C398.04 418.585 389.44 412.725 379.85 410.905L380.26 416.615C380.26 416.615 388.86 415.825 393.45 417.205Z"
                fill="#58595B"
              />
              <path
                d="M416.25 364.615L426.52 394.375L418.81 387.515L427.18 454.345C427.18 454.345 426.66 485.855 405.7 488.055C384.18 490.315 389.01 459.535 389.01 459.535C389.01 459.535 347.52 470.425 334.11 513.215C334.11 513.215 333.1 524.715 336.75 537.035C342.6 556.795 363.65 579.385 393.21 577.825C436.41 575.535 449.27 525.905 449.4 525.045C451.59 509.975 439.95 509.355 415.81 512.155C406.04 513.285 396.81 513.305 390.48 511.165C381.16 508.015 376.95 501.915 376.95 501.915C376.95 501.915 376.63 517.225 390.06 521.845C399.56 525.115 405.51 527.665 408.19 528.875C409.12 529.295 409.56 530.375 409.2 531.325L404.97 542.325C404.6 543.295 403.54 543.795 402.56 543.465C397.56 541.775 383.02 537.205 375.24 538.345C365.75 539.735 347.85 553.345 347.85 553.345C347.85 553.345 346.34 551.645 344.42 548.605C342.5 545.565 341.53 543.315 341.53 543.315C341.53 543.315 355.92 531.005 371.15 524.905C371.15 524.905 368.34 513.575 368.78 503.525C369.22 493.475 369.37 471.235 369.37 471.235L378.07 466.065C378.07 466.065 377.39 486.835 390.37 493.975C397.75 498.035 404.07 498.995 412.35 498.915C418.64 498.855 425.65 497.355 433.96 497.315C453.24 497.225 453.78 510.815 453.8 516.965C453.82 521.185 451.86 553.885 431.27 574.495C421.84 583.925 408.48 591.885 389.67 591.545C357.69 590.965 339.13 572.595 332.26 551.755C328.17 539.345 329.1 526.095 331.38 515.125C334.89 498.245 337.3 484.085 357.06 463.595C357.06 463.595 342.85 461.075 337.42 444.335C337.42 444.335 335 436.075 338.96 427.225C342.92 418.375 345.42 415.545 351.03 412.285C357.17 408.715 366.7 409.775 366.7 409.775L366.73 417.625C366.73 417.625 346.41 421.795 342.82 427.835C341.34 430.325 342.68 444.245 359.53 448.485C375.99 452.625 400.37 443.015 406.9 439.925C407.47 439.655 408.07 440.235 407.83 440.815L402.17 454.425L393.37 458.085C393.37 458.085 391.38 471.535 403.73 472.555C414.7 473.455 420.25 468.255 420.18 467.025C419.97 463.805 409.82 380.205 409.82 380.205C409.82 380.205 410 379.475 409.11 378.115C408.22 376.755 407.03 376.035 408.66 371.705C410.28 367.375 412.97 362.615 412.97 362.615C412.97 362.615 414.52 360.445 416.25 364.615Z"
                fill="#58595B"
              />
              <path
                d="M368.44 447.615L378.63 446.745C378.63 446.745 378.69 378.435 373.17 345.365C373.1 344.945 372.53 344.865 372.35 345.245C370.61 348.835 365.64 359.215 365.6 360.615C365.55 362.315 370.06 397.845 368.44 447.615Z"
                fill="#58595B"
              />
              <path
                d="M316.88 566.675C309.78 573.085 301.24 579.345 292.41 577.515C270.4 572.965 290.86 539.785 288.41 538.745C285.96 537.705 258.05 592.035 295.67 595.145C305.75 595.975 315.82 585.395 323.82 576.735C330.29 569.735 335.61 564.785 335.61 564.785C335.61 564.785 334.48 563.515 332.76 559.625C331.13 555.945 330.57 553.375 330.57 553.375C330.57 553.375 324.41 559.875 316.88 566.675Z"
                fill="#58595B"
              />
            </g>
            <path
              id="al"
              d="M420.16 345.56C419.47 344.88 418.29 345.17 418.01 346.1L414.04 359.19C413.77 360.07 414.08 361.03 414.8 361.6C415.21 361.92 415.63 362.25 415.85 362.43C440.25 382.28 504.38 456.66 454.25 582.92C454.02 583.65 454.94 584.08 455.22 583.37C474.33 557.45 524.73 449.13 420.16 345.56Z"
              fill="#58595B"
            />
          </g>
          <g id="Group 1">
            <path
              id="a1"
              d="M340.31 347.08C335.85 335.47 328.46 327.34 334.95 321.98C338.12 330.31 349.88 320.94 340.6 316.43C334.5 313.46 323.16 321.14 329.29 336.37C332.36 344.01 337.02 346.89 337.02 357.7C337.02 357.7 324.66 337.1 320.26 351.73C319.03 355.83 322.28 356.83 323.3 356.07C329.19 351.63 334.89 357.19 336.09 369.68C336.19 370.72 337.54 371.1 338.11 370.22C341.23 365.52 344.03 356.76 340.31 347.08Z"
              fill="#58595B"
            />
            <path
              id="a2"
              d="M329.59 375.49C327.37 373.04 321.21 378.49 319.73 382.82C318.24 387.15 324.21 389.85 324.21 389.85C314.98 399.76 291.92 406.97 291.92 406.97C310.92 407.33 325.38 389.96 325.38 389.96C325.38 389.96 325.87 391.59 328.13 392.27C330.4 392.95 328.39 386.94 328.39 386.94C330.79 383.21 331.82 377.94 329.59 375.49ZM327.55 386.41C327.55 386.41 324.04 384.95 322.87 383.66C321.7 382.37 322.9 380.4 322.9 380.4C322.9 380.4 324.36 378.07 327.62 378.99C330.89 379.91 327.55 386.41 327.55 386.41Z"
              fill="#58595B"
            />
          </g>
          <g id="Group_3">
            <g id="Vector_3">
              <path
                d="M302.86 210.19C294.84 221.65 285.48 236.47 278.53 251.79C283.67 240.17 291.18 226.65 302.86 210.19Z"
                fill="#58595B"
              />
              <path
                d="M261.79 232.04C262.01 243.16 256.58 261.71 256.25 262.81C257.49 253.26 254.95 239.09 254.95 239.09L233.96 263.69C237.24 286.08 232.48 320.82 232.48 320.82C232.11 304.35 225.74 284.74 225.74 284.74C217.17 325.08 148.48 345.96 142.34 409.19C136.67 467.68 168.87 490.09 168.87 490.09C175.99 381.15 246.07 349.49 271.89 269.51C272.98 266.14 274.1 262.42 275.71 258.4C276.56 256.28 277.47 254.15 278.43 252.04C278.46 251.96 278.49 251.88 278.54 251.8C285.49 236.48 294.85 221.66 302.87 210.2C302.98 210.03 303.1 209.86 303.21 209.7C311.13 198.43 317.64 190.52 319.14 188.74C319.18 188.69 319.22 188.63 319.26 188.59C319.35 188.48 319.42 188.4 319.44 188.37C302.85 198.72 261.79 232.04 261.79 232.04ZM161.9 463.72C122.97 387.86 203.63 340.49 203.63 340.49C140.94 397.39 161.9 463.72 161.9 463.72Z"
                fill="#58595B"
              />
            </g>
            <g id="Vector_4">
              <path
                d="M319.44 188.36C319.44 188.36 319.44 188.37 319.43 188.37C319.41 188.4 319.35 188.48 319.25 188.59C319.21 188.63 319.17 188.69 319.13 188.74C313.1 196.22 307.83 203.19 303.2 209.7C303.09 209.86 302.97 210.03 302.86 210.2C294.84 221.66 285.48 236.48 278.53 251.8C278.49 251.88 278.46 251.96 278.42 252.04C275.63 258.38 273.55 264.14 271.88 269.51C265.84 289 265.25 303.31 256.3 320.52C247.99 336.5 239.29 349.66 230.68 362.1C212.34 388.66 194.48 411.99 182.08 452.74C163.15 514.96 194.26 584.43 194.77 585.49C174.45 496.78 205.92 456.99 254.78 428.32C244.42 434.4 218.29 438.38 217.36 438.57C258.36 422.29 270.69 396.61 270.69 396.61C241.41 414.64 233.62 412.13 233.62 412.13C279.86 389.2 303.41 345.43 303.41 345.43C280.21 366.72 268.19 366.82 267.97 366.82C289.28 354.9 306.05 336.01 309.41 313.77C312.86 290.91 305.8 285.92 304.45 258.01C303.07 229.13 319.44 188.36 319.44 188.36Z"
                fill="#FFD400"
              />
              <path
                d="M199.14 591.22C198.71 590.75 197.96 591.26 198.23 591.84C204.82 605.76 236.36 659.69 327.02 652.96C388.1 648.43 424.64 615.17 435.61 603.61C436.12 603.07 435.44 602.26 434.82 602.67C421.94 611.21 380.98 635.3 323.26 639.35C253.06 644.28 209.34 602.25 199.14 591.22Z"
                fill="#FFD400"
              />
            </g>
          </g>
        </g>
      </g>
    </svg> -->

    <svg
      class="panda-carector pc-1 robot"
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 798.35 1173.54"
    >
      <defs></defs>
      <title>الروبوت</title>
      <path
        class="cls-1"
        d="M436.75,998.21l-54.46-8a204.77,204.77,0,0,0,10.26-69.85l54.46,8a152.37,152.37,0,0,1-10.26,69.85Z"
        transform="translate(-23.54 -2.05)"
      />
      <path
        class="cls-2"
        d="M437,998.6c-4.17,0-8.58-.14-13.06-.32s-9.1-.45-13.78-.84-9.42-.81-14.17-1.36-9.53-1.14-14.27-1.88l-.1,0a4,4,0,0,1-3.31-4.55,4.83,4.83,0,0,1,.17-.68l2.86-8.23c1-2.74,1.9-5.5,2.85-8.27a141.36,141.36,0,0,0,4.68-17,108.15,108.15,0,0,0,2-17.49,129,129,0,0,0-.72-17.58,2.29,2.29,0,0,1,2-2.51,1.7,1.7,0,0,1,.39,0l.38,0c4.59.33,9.18.6,13.76,1s9.15.86,13.71,1.37l13.68,1.58c4.55.56,9.11,1.07,13.66,1.72a4.81,4.81,0,0,1,4.1,4.32v0a119.63,119.63,0,0,1,.3,18.35c-.16,3.06-.49,6.1-.88,9.13s-.87,6-1.51,9a121.17,121.17,0,0,1-5,17.52c-1,2.85-2.17,5.65-3.45,8.39-.62,1.37-1.29,2.73-2,4.06-.34.68-.69,1.34-1.06,2l-.28.51-.33.6C437.44,997.92,437.19,998.27,437,998.6Zm-.45-.78.12-1,.07-.43.12-.53.5-2.18,1-4.34q.91-4.33,1.67-8.67c1-5.78,1.77-11.56,2.26-17.34.22-2.89.45-5.77.57-8.66s.14-5.77.15-8.65c0-5.76-.26-11.51-.73-17.24l4.1,4.35c-4.53-.68-9.05-1.5-13.57-2.28l-13.56-2.42c-4.51-.83-9-1.66-13.52-2.63s-9-2-13.46-3l2.8-2.49c-.3,6-.78,12-1.29,17.88S392.62,950,392,956s-1.11,11.92-2,17.88c-.42,3-1,5.94-1.61,8.9s-1.42,5.86-2.33,8.73l-3.24-5.25c4.34.59,8.64,1.31,13,2.11S404.5,990,408.91,991s8.87,2,13.45,3.16S431.61,996.45,436.53,997.82Z"
        transform="translate(-23.54 -2.05)"
      />
      <line class="cls-1" x1="375.54" y1="959.26" x2="413.28" y2="957.64" />
      <path
        class="cls-3"
        d="M399.07,961.31a28.18,28.18,0,0,1,9.26-4.59,39.06,39.06,0,0,1,9.39-1.56,38.55,38.55,0,0,1,9.48.73,28.13,28.13,0,0,1,9.62,3.8,28,28,0,0,1-9.26,4.6,38.07,38.07,0,0,1-9.39,1.54,38.56,38.56,0,0,1-9.48-.74A28.19,28.19,0,0,1,399.07,961.31Z"
        transform="translate(-23.54 -2.05)"
      />
      <path
        class="cls-1"
        d="M459.62,482.28l-54.47,7.94A204.88,204.88,0,0,0,395,420.35l54.47-7.93a152.21,152.21,0,0,1,10.18,69.86Z"
        transform="translate(-23.54 -2.05)"
      />
      <path
        class="cls-2"
        d="M460,482.59c-4,1.23-8.26,2.32-12.6,3.44s-8.85,2.17-13.45,3.14-9.25,1.92-14,2.76-9.45,1.64-14.21,2.28h-.1a4,4,0,0,1-4.48-3.41,4.15,4.15,0,0,1,0-.7l.38-8.7c.17-2.91.25-5.82.36-8.75a139.49,139.49,0,0,0-.37-17.58,108.58,108.58,0,0,0-3.12-17.33,128.54,128.54,0,0,0-5.73-16.63,2.29,2.29,0,0,1,1.23-3l.37-.12.38-.08c4.49-1,9-2.06,13.47-3s9-1.79,13.52-2.61l13.56-2.41c4.52-.76,9-1.58,13.58-2.26a4.81,4.81,0,0,1,5.17,3v0a119.72,119.72,0,0,1,5.54,17.5c.72,3,1.28,6,1.77,9s.9,6,1.14,9.08a120.38,120.38,0,0,1,.28,18.21c-.19,3-.47,6-.91,9-.2,1.5-.46,3-.74,4.46-.13.75-.28,1.48-.44,2.22l-.12.57-.15.67C460.2,481.81,460.06,482.22,460,482.59Zm-.65-.62-.17-1-.06-.43,0-.54-.14-2.23-.33-4.44c-.25-2.94-.54-5.87-.89-8.78-.7-5.82-1.62-11.58-2.8-17.26-.61-2.83-1.22-5.66-1.93-8.46s-1.52-5.57-2.34-8.34q-2.52-8.26-5.64-16.3l5.18,3c-4.54.65-9.1,1.15-13.66,1.71l-13.68,1.56c-4.56.5-9.12,1-13.71,1.35s-9.18.64-13.76,1l2-3.19c1.43,5.83,2.68,11.67,3.89,17.5s2.35,11.67,3.49,17.52,2.35,11.74,3.22,17.7c.46,3,.76,6,1,9s.31,6,.26,9l-4.61-4.1c4.33-.68,8.66-1.22,13-1.69s8.78-.87,13.27-1.21,9.1-.58,13.79-.83S454.2,482.07,459.3,482Z"
        transform="translate(-23.54 -2.05)"
      />
      <line class="cls-1" x1="387.42" y1="455.29" x2="424.71" y2="449.25" />
      <path
        class="cls-3"
        d="M411,457.34a28.19,28.19,0,0,1,8.66-5.65,38.62,38.62,0,0,1,9.13-2.64,37.68,37.68,0,0,1,9.51-.39,27.83,27.83,0,0,1,10,2.64,27.89,27.89,0,0,1-8.65,5.66,38.07,38.07,0,0,1-9.14,2.63,38.57,38.57,0,0,1-9.5.37A28.25,28.25,0,0,1,411,457.34Z"
        transform="translate(-23.54 -2.05)"
      />
      <path
        class="cls-2"
        d="M383.22,124.83a72,72,0,0,0,8.17-9.24,61.72,61.72,0,0,0,6.12-10.09,49.82,49.82,0,0,0,5.16-21.24,35.67,35.67,0,0,0-1.34-9.78,25.23,25.23,0,0,0-1.67-4.22,21.23,21.23,0,0,0-2.2-3.59,20.51,20.51,0,0,0-5.87-5.1,27.87,27.87,0,0,0-7.86-3c-1.47-.34-3-.63-4.59-.84s-3.22-.36-4.91-.4-3.38-.06-5.11,0-3.47.16-5.21.34-3.49.4-5.2.68c-.85.14-1.7.3-2.48.47-.4.08-.78.17-1.07.25l-.44.13-.57.15a73.75,73.75,0,0,0-9.4,3.37A60,60,0,0,0,336,67.43a33.71,33.71,0,0,0-6.5,5.16,10.47,10.47,0,0,0-1.53,2c-.28.5-.21.7-.16.48a2.84,2.84,0,0,0,.07-1.06c-.05-.08,0-.08,0-.12s-.07,0,0,0a.1.1,0,0,1,0,.1,1.06,1.06,0,0,1,.17.23l.06.13.15.16a3.32,3.32,0,0,1,.26.36c.12.13.27.26.4.41a2.49,2.49,0,0,0,.43.43,9.22,9.22,0,0,0,1.08.91c.37.32.82.61,1.27.93a19.64,19.64,0,0,0,6.1,2.8l.78.21.74.13a10.75,10.75,0,0,0,1.4.18,3,3,0,0,0,.67,0c.21,0,.43,0,.64,0a6.68,6.68,0,0,0,1.33-.1,16.27,16.27,0,0,0,5.8-1.84,26.16,26.16,0,0,0,5.83-4.5,27,27,0,0,0,4.69-6.22,26.53,26.53,0,0,0,2.44-6.7,13.9,13.9,0,0,0,0-6.22A22.52,22.52,0,0,0,361.09,52a23.55,23.55,0,0,0-1.88-3.5,39.19,39.19,0,0,0-6-6.93,54.38,54.38,0,0,0-8.1-6.15c-1.49-.9-3-1.81-4.56-2.63s-3.15-1.56-4.76-2.24a51.65,51.65,0,0,0-9.83-3,44.54,44.54,0,0,0-5.2-.7c-.88-.08-1.77-.11-2.66-.17s-1.79,0-2.7,0a53.45,53.45,0,0,0-5.46.42c-.91.12-1.84.23-2.76.4s-1.84.33-2.76.54a67,67,0,0,0-11,3.51l-.43.18a3.08,3.08,0,0,1-2.86-5.44A65.29,65.29,0,0,1,313.84,17a56.7,56.7,0,0,1,25.47,1.46,71.35,71.35,0,0,1,22.87,11.33,52.55,52.55,0,0,1,9.32,8.94,37.81,37.81,0,0,1,6.36,11.39,34,34,0,0,1,1.44,6.45,29.82,29.82,0,0,1,0,6.61,39.15,39.15,0,0,1-3.45,12.59,44.41,44.41,0,0,1-7.16,10.87,43.51,43.51,0,0,1-10,8.38,35.63,35.63,0,0,1-12.36,4.51,20.32,20.32,0,0,1-3.3.36c-1.11,0-2.23.12-3.33,0a30.43,30.43,0,0,1-3.31-.35l-1.63-.27-1.61-.39a38.64,38.64,0,0,1-12-5.28l-1.37-.93c-.45-.31-.86-.68-1.3-1a30.36,30.36,0,0,1-2.49-2.2c-.81-.76-1.52-1.64-2.27-2.47l-1-1.36-.5-.69-.43-.73a19.82,19.82,0,0,1-2.57-6.4,16.25,16.25,0,0,1,.12-7,24.76,24.76,0,0,1,7-11.43,52.86,52.86,0,0,1,10.38-7.77,81.64,81.64,0,0,1,11.57-5.51,80.24,80.24,0,0,1,12.28-3.65,79,79,0,0,1,12.75-1.37,83.91,83.91,0,0,1,12.77.53,60,60,0,0,1,12.56,2.83,40.84,40.84,0,0,1,11.47,6.09,33,33,0,0,1,8.52,9.92c4.26,7.72,5.28,16.8,4,25.28a55.47,55.47,0,0,1-9.78,23.51,64.22,64.22,0,0,1-18.59,17.24,1,1,0,0,1-1.17-1.49Z"
        transform="translate(-23.54 -2.05)"
      />
      <path
        class="cls-2"
        d="M275.75,8.05a24.58,24.58,0,1,0,34.68,2.47A24.59,24.59,0,0,0,275.75,8.05Z"
        transform="translate(-23.54 -2.05)"
      />
      <rect
        class="cls-4"
        x="683.1"
        y="191.81"
        width="78.52"
        height="78.52"
        rx="22.77"
        transform="translate(-49.31 104.52) rotate(-8.29)"
      />
      <path
        class="cls-2"
        d="M744.42,268c-5.67.8-11.3,1.9-16.89,3.25-2.8.67-5.58,1.42-8.37,2.17L715,274.58c-1.42.37-2.67.79-4.38,1.08a24.29,24.29,0,0,1-9.93-.23,17.05,17.05,0,0,1-2.44-.71,22.16,22.16,0,0,1-2.37-1,21.15,21.15,0,0,1-2.25-1.21,19.39,19.39,0,0,1-2.13-1.44,25,25,0,0,1-9.78-17.45c-.52-5.71-.74-11.47-1.06-17.21-.13-2.87-.34-5.74-.52-8.61-.1-1.43-.24-2.86-.36-4.29s-.3-2.8-.39-4.38a26.43,26.43,0,0,1,5.14-17.25A26.33,26.33,0,0,1,700,191.84l8.4-1.91,4.21-1,4.21-.89q4.22-.9,8.44-1.66l4.23-.77c1.46-.25,2.67-.53,4.53-.72a27.31,27.31,0,0,1,10.36.8,27.85,27.85,0,0,1,9.39,4.67,26.77,26.77,0,0,1,7,7.9,27.33,27.33,0,0,1,3.46,10c.73,5.68,1.42,11.37,2,17.08q.39,4.29.62,8.59c.07,1.44.15,2.88.19,4.32s.11,2.78.09,4.53a25.48,25.48,0,0,1-2,9.45A26.6,26.6,0,0,1,744.42,268Zm-.14-1a20.13,20.13,0,0,0,7.77-3,19.37,19.37,0,0,0,8.31-20.7c-.23-1.11-.65-2.62-1-4s-.71-2.79-1.06-4.19c-.67-2.79-1.29-5.6-1.85-8.41-1.1-5.63-2.06-11.28-3-16.93a18.66,18.66,0,0,0-6.32-11.16,17.93,17.93,0,0,0-12.34-4.22c-1,0-2.61.23-4,.38l-4.27.47c-2.85.31-5.7.59-8.56.81l-4.3.35-4.3.29-8.6.56a19.33,19.33,0,0,0-18.14,21.54c.12,1.28.46,2.74.71,4.14s.57,2.81.89,4.21c.64,2.8,1.25,5.61,2,8.4,1.34,5.6,2.76,11.18,3.89,16.8a21.19,21.19,0,0,0,7,11.62,21.54,21.54,0,0,0,13,5.14c1.15.09,2.72,0,4.14,0l4.32-.11c2.88-.08,5.77-.15,8.64-.31Q735.79,268.3,744.28,267Z"
        transform="translate(-23.54 -2.05)"
      />
      <path
        class="cls-1"
        d="M638.3,154.79l62.11-7.71a348.2,348.2,0,0,1,22.08,178l-62.11,7.71Z"
        transform="translate(-23.54 -2.05)"
      />
      <path
        class="cls-2"
        d="M637.9,154.48l14.73-3c5-1,10.14-2,15.36-3l7.86-1.46,8-1.37,8-1.35,8.07-1.26a3.86,3.86,0,0,1,4.12,2.27l.09.21A278.77,278.77,0,0,1,719,189a266.32,266.32,0,0,1,6.82,45.3c1.07,15.22,1.45,30.41,1.48,45.58s-.65,30.38-2,45.57a2.64,2.64,0,0,1-2.19,2.38l-.26,0-15.44,2.63c-5.14.9-10.3,1.71-15.45,2.54s-10.32,1.55-15.48,2.33L661,337.57a4.76,4.76,0,0,1-5.39-4l0-.18q-1.64-11.31-3.17-22.68l-1.55-11.38-1.44-11.39c-1.85-15.19-3.4-30.38-4.78-45.43-.68-7.53-1.4-15-2-22.49l-.93-11.16-.86-11.07C639.74,183.06,638.7,168.54,637.9,154.48Zm.8.62c2.88,15.6,5.52,30.74,8.08,45.7L648.69,212l1.83,11.09c1.25,7.39,2.37,14.7,3.53,22,2.3,14.61,4.43,29.08,6.26,43.55l1.33,10.85,1.21,10.87q1.23,10.89,2.35,21.82l-5.41-4.22,15.56-1.63c5.19-.5,10.38-1.06,15.58-1.52s10.39-.93,15.6-1.32l15.62-1.23-2.46,2.42a259,259,0,0,0,4.51-44.82A236.77,236.77,0,0,0,720.39,235c-2.64-14.8-6.31-29.31-10.18-43.71-2-7.19-4-14.38-6.25-21.48s-4.68-14.18-7.27-21.19l4.21,2.48-7.45.67-7.51.58-7.56.55-7.67.47-15.69.89Z"
        transform="translate(-23.54 -2.05)"
      />
      <rect
        class="cls-4"
        x="83.58"
        y="272.15"
        width="78.52"
        height="78.52"
        rx="22.77"
        transform="translate(-50.45 9.97) rotate(-5.05)"
      />
      <path
        class="cls-2"
        d="M142.77,349.58c-5.71.48-11.39,1.26-17.05,2.29-2.83.51-5.65,1.1-8.48,1.69l-4.23.88c-1.44.29-2.72.63-4.43.83a24.35,24.35,0,0,1-9.91-.79,16.67,16.67,0,0,1-2.4-.85A20.25,20.25,0,0,1,94,352.54a22.38,22.38,0,0,1-2.18-1.34,19.21,19.21,0,0,1-2-1.55,25.06,25.06,0,0,1-8.78-18c-.19-5.74-.09-11.5-.08-17.25,0-2.88,0-5.75,0-8.62,0-1.44-.07-2.87-.11-4.31s-.14-2.81-.14-4.39a26.37,26.37,0,0,1,6.11-16.94,26.75,26.75,0,0,1,7.08-6,26.42,26.42,0,0,1,8.93-3.19l8.5-1.44,4.25-.72,4.26-.64c2.83-.45,5.67-.83,8.52-1.19l4.27-.53c1.46-.16,2.69-.37,4.55-.46a27.24,27.24,0,0,1,10.31,1.39,27.91,27.91,0,0,1,9.11,5.19,26.79,26.79,0,0,1,6.54,8.28,27.34,27.34,0,0,1,2.88,10.18c.42,5.72.78,11.44,1,17.17.1,2.86.15,5.74.14,8.61,0,1.44,0,2.88-.06,4.32s0,2.78-.16,4.53a25.44,25.44,0,0,1-2.56,9.32,26.66,26.66,0,0,1-21.5,14.58Zm-.09-1a20.2,20.2,0,0,0,7.93-2.51,19.29,19.29,0,0,0,6.08-5.45,19.51,19.51,0,0,0,3.39-14.74c-.17-1.12-.5-2.66-.78-4s-.55-2.83-.81-4.24c-.52-2.83-1-5.67-1.38-8.51-.78-5.68-1.42-11.37-2-17.07a18.65,18.65,0,0,0-5.68-11.5,18,18,0,0,0-12.09-4.91c-1-.05-2.62.08-4,.15L129,276q-4.29.22-8.6.33l-4.3.1-4.31,0-8.62.08A19.32,19.32,0,0,0,83.87,297c0,1.29.3,2.77.47,4.17s.41,2.84.65,4.26c.48,2.83.94,5.67,1.47,8.5,1,5.66,2.13,11.31,2.94,17a21.17,21.17,0,0,0,6.33,12,21.52,21.52,0,0,0,12.66,5.87c1.15.15,2.73.16,4.14.21l4.32.13c2.89.09,5.77.17,8.65.18C131.25,349.33,137,349.1,142.68,348.57Z"
        transform="translate(-23.54 -2.05)"
      />
      <path
        class="cls-1"
        d="M204.37,395.13l-62.1,7.8A348.15,348.15,0,0,1,119.91,225l62.1-7.8Z"
        transform="translate(-23.54 -2.05)"
      />
      <path
        class="cls-2"
        d="M204.77,395.44l-14.73,3c-5,1-10.14,2-15.36,3l-7.85,1.48-8,1.38-8,1.36-8.07,1.27a3.83,3.83,0,0,1-4.12-2.26l-.09-.21a279.75,279.75,0,0,1-14.93-43.37,267.45,267.45,0,0,1-6.89-45.3c-1.09-15.22-1.49-30.4-1.55-45.58s.6-30.37,1.92-45.57a2.65,2.65,0,0,1,2.18-2.38l.27,0L135,219.55c5.15-.91,10.3-1.73,15.45-2.56s10.32-1.57,15.47-2.36l15.49-2.25a4.75,4.75,0,0,1,5.39,4l0,.18q1.65,11.31,3.21,22.67l1.56,11.38L193.05,262c1.87,15.19,3.45,30.38,4.85,45.42.69,7.53,1.43,15.05,2,22.49l.95,11.15.87,11.07C202.89,366.86,204,381.38,204.77,395.44Zm-.8-.62c-2.9-15.6-5.57-30.73-8.16-45.69L193.89,338,192,326.87c-1.26-7.39-2.39-14.69-3.56-22-2.33-14.61-4.48-29.07-6.33-43.54l-1.35-10.85-1.23-10.87q-1.23-10.87-2.38-21.81l5.42,4.21-15.56,1.66c-5.19.51-10.38,1.07-15.58,1.54s-10.39.95-15.6,1.34l-15.61,1.25,2.45-2.42a259.09,259.09,0,0,0-4.44,44.83,236.83,236.83,0,0,0,3.88,44.88c2.66,14.79,6.36,29.3,10.25,43.69,2,7.19,4,14.37,6.28,21.47s4.7,14.17,7.31,21.18L141.77,399l7.45-.69,7.51-.58,7.56-.57,7.67-.48,15.69-.92Z"
        transform="translate(-23.54 -2.05)"
      />
      <path
        class="cls-5"
        d="M665.2,378.82a1170.06,1170.06,0,0,1-205.38,52.41,1170.58,1170.58,0,0,1-246.63,13.12A499.66,499.66,0,0,1,168.41,269a489.68,489.68,0,0,1,4.21-104.55A920.57,920.57,0,0,1,624.63,99,545,545,0,0,1,665.2,378.82Z"
        transform="translate(-23.54 -2.05)"
      />
      <path
        class="cls-2"
        d="M665.59,379.14l-6.8,2.67c-2.3.9-4.65,1.8-6.86,2.61q-6.73,2.52-13.52,4.92c-9,3.24-18.12,6.29-27.25,9.25-18.25,6-36.7,11.28-55.26,16.21s-37.29,9.25-56.1,13.17S462,435.18,443,438.14A1079.12,1079.12,0,0,1,328.27,449.2,1062.33,1062.33,0,0,1,213,447.27h-.1a2.84,2.84,0,0,1-2.4-1.69q-7.25-16.51-13.35-33.46c-4.08-11.3-7.7-22.74-11-34.26-1.7-5.75-3.16-11.57-4.68-17.37-1.34-5.84-2.86-11.64-4.06-17.52s-2.41-11.74-3.53-17.63c-.56-2.94-1-5.91-1.49-8.86s-1-5.91-1.39-8.88l-1.25-8.9c-.42-3-.7-6-1.05-8.93-.74-5.95-1.17-11.93-1.68-17.9-1-11.95-1.48-23.94-1.56-35.94s.21-24,1-36,1.89-23.94,3.48-35.85a2.71,2.71,0,0,1,1.6-2.13l.08,0A880.41,880.41,0,0,1,393.77,98.28q28.69-4.29,57.61-6.83c19.28-1.65,38.61-2.54,57.95-2.94s38.69-.05,58,.89S606,91.82,625.15,94h.1a4.89,4.89,0,0,1,3.94,3,533.12,533.12,0,0,1,42,210.43c-.1,12-.56,23.93-1.49,35.85-.47,6-1,11.91-1.67,17.85-.32,3-.7,5.93-1.08,8.89l-.29,2.22-.34,2.33Zm-.79-.63.3-4.31.33-4.34c.22-3,.43-5.93.6-8.91.37-5.93.62-11.88.81-17.82.34-11.89.36-23.77-.06-35.64A568.38,568.38,0,0,0,660,236.71a563.69,563.69,0,0,0-15.63-69.22q-5-17-11.08-33.68t-13.21-32.87l4,3c-19-1.82-38.12-3.23-57.23-4s-38.23-.88-57.34-.58a950.6,950.6,0,0,0-114.3,8.93,920.75,920.75,0,0,0-112.44,22.78,973,973,0,0,0-109.11,36l1.68-2.15q-2.85,17.6-4.43,35.38c-1,11.85-1.62,23.74-1.72,35.65s.2,23.81,1,35.69c.48,5.94.88,11.88,1.59,17.79.34,3,.6,5.93,1,8.88l1.2,8.85c.37,3,.88,5.89,1.38,8.83s1,5.88,1.54,8.8c1.15,5.84,2.25,11.69,3.62,17.49s2.74,11.59,4.22,17.36c1.63,5.73,3.18,11.47,5,17.15a474,474,0,0,0,26.08,66.36l-2.51-1.7c38.2,1.32,76.41.79,114.52-1.15s76.15-5.35,114-10.65q28.35-3.92,56.52-9.15t56.09-11.64c18.63-4.26,37.15-9,55.58-14.1,4.61-1.3,9.22-2.56,13.81-3.92s9.19-2.64,13.77-4,9.16-2.78,13.74-4.17Z"
        transform="translate(-23.54 -2.05)"
      />
      <rect
        class="cls-6"
        x="225.96"
        y="155.64"
        width="388.55"
        height="232.37"
        rx="63.84"
        transform="translate(-58.34 61.39) rotate(-8.29)"
      />
      <path
        class="cls-2"
        d="M566.14,368.49q-35,5.07-69.92,11l-17.44,3-17.44,3.05-34.86,6.1c-11.63,2-23.25,4-34.9,5.89l-17.46,2.85-17.49,2.72q-17.49,2.65-35,5.15l-8.76,1.23-4.39.6c-1.57.16-3.13.4-4.7.45a67.73,67.73,0,0,1-9.45,0,73.45,73.45,0,0,1-9.34-1.34,67.38,67.38,0,0,1-32.58-17.68,66.49,66.49,0,0,1-18.1-31.92c-.37-1.49-.65-3-.93-4.51s-.47-3.06-.63-4.5l-1.1-8.78-2.21-17.55q-2.3-17.55-4.68-35.08c-1.67-11.68-3.24-23.37-5-35-.42-2.92-.89-5.8-1.23-8.83a65.13,65.13,0,0,1-.29-9c0-1.51.2-3,.31-4.53s.35-3,.64-4.48a62.31,62.31,0,0,1,2.15-8.82,66.94,66.94,0,0,1,19.82-30,65.28,65.28,0,0,1,7.32-5.49,62,62,0,0,1,8-4.46A66.6,66.6,0,0,1,274,172.91l34.91-5.78,17.46-2.89,17.47-2.82c23.29-3.75,46.6-7.33,69.92-10.92l70-10.7c11.66-1.8,23.33-3.5,35-5.21l8.75-1.28,4.38-.64c1.59-.18,3.17-.44,4.77-.51a67.33,67.33,0,0,1,19.1,1.21,69.46,69.46,0,0,1,33.45,17.68A68.67,68.67,0,0,1,601,166a67.91,67.91,0,0,1,4.23,8.55,72.66,72.66,0,0,1,2.94,9.07c.4,1.53.7,3.09,1,4.64s.52,3.17.69,4.59L611,201.6l2.18,17.56c1.49,11.7,2.8,23.43,4.17,35.15l4.09,35.16c.34,2.94.71,5.82,1,8.89a66,66,0,0,1,0,9.11c-.06,1.52-.28,3-.43,4.53s-.43,3-.77,4.47a62.62,62.62,0,0,1-2.43,8.72,69.2,69.2,0,0,1-8.23,16,72.89,72.89,0,0,1-5.64,7,67.57,67.57,0,0,1-6.54,6.12A65.8,65.8,0,0,1,566.14,368.49Zm-.15-1a63.71,63.71,0,0,0,16.77-5,60.74,60.74,0,0,0,7.68-4.19,58.73,58.73,0,0,0,7-5.23,61.8,61.8,0,0,0,18.75-28.79,60.71,60.71,0,0,0,1.92-8.42c.25-1.41.36-2.85.53-4.27l.13-2.15c.05-.72.07-1.43.06-2.15a62.65,62.65,0,0,0-.5-8.56c-.38-2.79-.94-5.73-1.44-8.63l-6.11-34.87c-2-11.62-4.12-23.23-6-34.87l-2.92-17.46-1.39-8.73c-.23-1.51-.49-2.8-.74-4.15s-.59-2.66-1-4A59.1,59.1,0,0,0,553.54,144a69.66,69.66,0,0,0-8-1,59,59,0,0,0-8.09,0c-1.35.06-2.68.29-4,.43L529,144l-8.75,1.26c-11.67,1.7-23.34,3.4-35,5l-70.1,9.7c-23.37,3.21-46.74,6.43-70.13,9.49l-17.54,2.28L309.93,174l-35.11,4.42a60.89,60.89,0,0,0-30.88,13.2,66.24,66.24,0,0,0-6.24,5.84,69.2,69.2,0,0,0-5.39,6.67,62.83,62.83,0,0,0-7.7,15.31,59.56,59.56,0,0,0-2.19,8.32c-.31,1.4-.45,2.84-.66,4.26s-.3,2.86-.32,4.29a63.56,63.56,0,0,0,.22,8.62c.3,2.83.75,5.78,1.16,8.7,1.65,11.67,3.48,23.33,5.2,35s3.66,23.31,5.54,34.95L236.44,341l1.46,8.73c.23,1.48.52,2.84.79,4.23s.63,2.75,1,4.1a60.3,60.3,0,0,0,17.61,28.12,60.93,60.93,0,0,0,6.55,5.14,56,56,0,0,0,7.17,4.21,61.79,61.79,0,0,0,15.64,5.28,64.31,64.31,0,0,0,8.18,1,59.49,59.49,0,0,0,8.23-.16c1.37-.07,2.73-.32,4.09-.48l4.37-.67,8.75-1.31q17.49-2.62,35-5.06l17.53-2.39,17.55-2.25c11.69-1.54,23.41-2.89,35.12-4.31l35.16-4.1,17.58-2,17.57-2.14Q531,372.64,566,367.48Z"
        transform="translate(-23.54 -2.05)"
      />
      <path
        class="cls-1"
        d="M110.17,822.59l-56,9.47c-2.72-36.37-1.69-94.48,24.11-157.56,18.22-44.55,41.45-73.59,48.21-81.79A305,305,0,0,1,207.07,524l45.3,36.76c-26.52,14.17-64.44,39.53-95.7,82.71a260.73,260.73,0,0,0-34.44,64.57A250,250,0,0,0,110.17,822.59Z"
        transform="translate(-23.54 -2.05)"
      />
      <path
        class="cls-2"
        d="M110.53,822.86l-27.45,5.91-14.12,3-14.32,2.87a2.53,2.53,0,0,1-3-2,1.87,1.87,0,0,1,0-.25v-.14a331,331,0,0,1-1.49-45.64c.24-7.63.8-15.24,1.55-22.84.42-3.79.92-7.58,1.39-11.37s1.16-7.55,1.79-11.31,1.38-7.52,2.15-11.26,1.7-7.45,2.63-11.16,2-7.38,3-11.06l3.49-10.92c1.3-3.59,2.56-7.19,3.89-10.77s2.9-7.07,4.34-10.6,3.11-7,4.68-10.44,3.3-6.87,5.1-10.23a371,371,0,0,1,23.48-39.08q3.21-4.7,6.61-9.27c2.24-3.06,4.51-6.1,6.87-9.08s4.78-5.9,7.26-8.76,5-5.74,7.49-8.57a332.45,332.45,0,0,1,69.7-58.43,2.89,2.89,0,0,1,3.29.16l.12.1,11.55,8.91,11.5,9c7.68,6,15.28,12,22.92,18a4,4,0,0,1,.67,5.65,3.92,3.92,0,0,1-1.21,1l-.11.06a298.81,298.81,0,0,0-32.92,21,288.36,288.36,0,0,0-29.71,25.21,281.88,281.88,0,0,0-47.78,61.23,252.54,252.54,0,0,0-17,35,255.55,255.55,0,0,0-11.21,37.4c-1.33,6.38-2.52,12.81-3.38,19.3s-1.53,13-2,19.54-.56,13.12-.53,19.7l.08,4.94.18,4.93.26,4.94C110.4,819.35,110.48,821.19,110.53,822.86Zm-.72-.54c-.32-1.62-.64-3.06-.88-4.58l-.7-4.93-.58-4.95-.47-5q-.84-9.93-.89-19.94a245.16,245.16,0,0,1,3.27-39.89,242.49,242.49,0,0,1,9.93-38.94A255,255,0,0,1,136,667.4a277.09,277.09,0,0,1,22-33.73,266,266,0,0,1,27-30,291.5,291.5,0,0,1,31.12-25.56,307.59,307.59,0,0,1,34.32-20.92l-.64,6.73c-7.47-6.23-15-12.42-22.39-18.7l-11.15-9.41-11.1-9.47,3.41.26a299.29,299.29,0,0,0-37.51,24.7,273.19,273.19,0,0,0-33.18,30.44c-20.54,22-36.54,48-48.75,75.3-1.59,3.39-3,6.88-4.44,10.31l-2,5.23c-.69,1.74-1.39,3.47-2,5.24-1.25,3.52-2.57,7-3.77,10.55s-2.32,7.1-3.48,10.65L70.3,709.81c-1,3.59-1.9,7.21-2.86,10.82s-1.67,7.27-2.51,10.9-1.49,7.31-2.25,11a390.11,390.11,0,0,0-5.88,89.36l-3-2.36,13.67-1.87,13.85-1.76Z"
        transform="translate(-23.54 -2.05)"
      />
      <path
        class="cls-4"
        d="M26.66,903.52c3.9,6.78,36.72.52,37,0-.69-3.08-4.43-21,6.89-36.16A40.83,40.83,0,0,1,85.21,855.3,30.86,30.86,0,0,1,104.15,857c12.36,5.59,20,20.31,18.94,37,.61.51,35.83-9.32,36.16-10.33-.33-2.48-7.29-49.18-43.91-63.72a64.57,64.57,0,0,0-33.58-3.44c-6.65,1.55-25.81,6.94-40.46,25C20,867.71,25.75,899,26.66,903.52Z"
        transform="translate(-23.54 -2.05)"
      />
      <path
        class="cls-2"
        d="M27.08,903.36a5.08,5.08,0,0,0,1.66,1.11,10.82,10.82,0,0,0,2.14.54,27.65,27.65,0,0,0,4.57.26,80.76,80.76,0,0,0,9.28-.83c3.1-.47,6.19-1,9.25-1.59,1.53-.31,3.06-.64,4.57-1l2.25-.53,1.08-.29.47-.14.11,0,0,0h0a2.32,2.32,0,0,0-.31.14,2,2,0,0,0-.43.29,2.54,2.54,0,0,0-.65.79l-.32,2.12a51.1,51.1,0,0,1-1.6-15.08A45.48,45.48,0,0,1,62.39,874a42.83,42.83,0,0,1,3.61-7,39,39,0,0,1,4.83-6.19,42.82,42.82,0,0,1,12.6-9.16l.09,0a3.87,3.87,0,0,1,.87-.29,33.55,33.55,0,0,1,17.56,1,27.72,27.72,0,0,1,4.11,1.78l1.94,1.09c.62.41,1.23.84,1.83,1.26a33.12,33.12,0,0,1,6.26,6.08,40.06,40.06,0,0,1,7.22,15.17,52,52,0,0,1,1.24,16.36l-.52-1.22a1.48,1.48,0,0,0-.46-.26l-.25,0h-.09l.21,0,.53-.09,1.11-.22,2.27-.51c1.52-.36,3-.75,4.55-1.14,3-.78,6-1.67,9-2.54l4.51-1.32,4.47-1.44c1.49-.48,3-1,4.44-1.48.73-.26,1.46-.52,2.17-.8.35-.14.7-.28,1-.43l.45-.21.13-.07h0l0,0-.11.09a1.47,1.47,0,0,0-.26.3,1.42,1.42,0,0,0-.2.41l-.08.8a86.81,86.81,0,0,0-3.76-13.52,104.76,104.76,0,0,0-5.58-12.85c-4.35-8.2-9.62-15.85-16.23-22a54.33,54.33,0,0,0-22.95-13,56.52,56.52,0,0,0-13.11-2,69.41,69.41,0,0,0-13.34.74l.37-.07a75.9,75.9,0,0,0-24.45,10.49A66.74,66.74,0,0,0,48,840.19c-.82.76-1.56,1.6-2.32,2.43l-1.13,1.24c-.38.42-.71.87-1.07,1.31a53.27,53.27,0,0,0-4,5.38l-1.88,2.81-1.64,3-.82,1.48c-.27.5-.49,1-.73,1.54l-1.45,3.09c-.44,1-.81,2.13-1.22,3.19l-.61,1.6c-.19.55-.34,1.1-.51,1.65l-1,3.29-.81,3.36a91.7,91.7,0,0,0-1.94,13.8c0,1.16-.12,2.33-.14,3.51s-.06,2.35,0,3.52.06,2.36.13,3.54S27,902.28,27.08,903.36Zm-.84.32c-.36-1.26-.65-2.39-.91-3.57s-.51-2.36-.7-3.55a72.39,72.39,0,0,1-.88-7.21A79.34,79.34,0,0,1,24,874.74a75.55,75.55,0,0,1,3.06-14.46l1.26-3.51c.22-.58.41-1.18.65-1.75l.78-1.7,1.57-3.41c.6-1.09,1.23-2.17,1.85-3.26a72.09,72.09,0,0,1,20.06-22.29,76.16,76.16,0,0,1,13.08-7.59c2.29-1.07,4.65-2,7-2.82s4.83-1.51,7.29-2.1l.32-.06h0a68.3,68.3,0,0,1,23,.25,69,69,0,0,1,7.5,1.85,61.4,61.4,0,0,1,14,6.4,63.63,63.63,0,0,1,12,9.59A77.63,77.63,0,0,1,153.62,855a112.45,112.45,0,0,1,4.63,14c.61,2.37,1.16,4.75,1.62,7.15s.89,4.78,1.16,7.29a1.86,1.86,0,0,1-.07.78v0a2.09,2.09,0,0,1-.56.83,1.84,1.84,0,0,1-.22.17,1.34,1.34,0,0,1-.17.11l-.13.07-.39.18-.63.25-1.18.39-2.3.7c-1.52.45-3,.88-4.56,1.3l-9.1,2.51-9.12,2.46L128,894.46l-2.31.59-1.19.28-.63.12-.37.06-.26,0H123l-.28-.07a1.58,1.58,0,0,1-.53-.28,1.39,1.39,0,0,1-.53-1.1V894a44.45,44.45,0,0,0-.39-7.66c-.14-1.27-.44-2.51-.69-3.76-.15-.61-.34-1.22-.51-1.83a16.34,16.34,0,0,0-.57-1.8,34.74,34.74,0,0,0-3.14-6.8,33.3,33.3,0,0,0-4.47-5.82,26.07,26.07,0,0,0-12-7.06,30,30,0,0,0-13.84,0l1-.34a40.66,40.66,0,0,0-10.37,7.55,32.68,32.68,0,0,0-4,5A34,34,0,0,0,69.44,877a40.85,40.85,0,0,0-3.3,12.58,49.33,49.33,0,0,0,.42,13.29l0,.24a2.71,2.71,0,0,1-.36,1.88,3.48,3.48,0,0,1-.78.86,3.74,3.74,0,0,1-.49.32,2.15,2.15,0,0,1-.38.17l-.26.08-.26.08-.18,0c-.24.05-.47.11-.68.14l-1.25.23c-.81.13-1.62.27-2.43.36-1.61.21-3.22.38-4.83.53-3.21.29-6.43.53-9.67.54a65.15,65.15,0,0,1-9.75-.5,26,26,0,0,1-4.85-1.08C28.88,906.18,27.18,905.49,26.24,903.68Z"
        transform="translate(-23.54 -2.05)"
      />
      <line class="cls-1" x1="139.71" y1="561.41" x2="163.41" y2="590.84" />
      <path
        class="cls-3"
        d="M163.25,563.46a28.37,28.37,0,0,1,9.19,4.72,39,39,0,0,1,6.81,6.64,37.9,37.9,0,0,1,5,8.07,27.82,27.82,0,0,1,2.65,10,28.13,28.13,0,0,1-9.2-4.72,39.64,39.64,0,0,1-11.83-14.72A28,28,0,0,1,163.25,563.46Z"
        transform="translate(-23.54 -2.05)"
      />
      <line class="cls-1" x1="111.45" y1="588.21" x2="139.65" y2="613.35" />
      <path
        class="cls-3"
        d="M135,590.26a28.13,28.13,0,0,1,9.84,3.16,39.18,39.18,0,0,1,7.82,5.42,38.72,38.72,0,0,1,6.29,7.13,28,28,0,0,1,4.25,9.43,27.92,27.92,0,0,1-9.84-3.15,39.57,39.57,0,0,1-14.09-12.58A28.36,28.36,0,0,1,135,590.26Z"
        transform="translate(-23.54 -2.05)"
      />
      <line class="cls-1" x1="85.28" y1="624.84" x2="116.59" y2="645.97" />
      <path
        class="cls-3"
        d="M108.81,626.89a28,28,0,0,1,10.17,1.8,38.94,38.94,0,0,1,8.48,4.33,38.48,38.48,0,0,1,7.19,6.22,28.06,28.06,0,0,1,5.48,8.77A28,28,0,0,1,130,646.22a39.61,39.61,0,0,1-15.65-10.58A28.16,28.16,0,0,1,108.81,626.89Z"
        transform="translate(-23.54 -2.05)"
      />
      <line class="cls-1" x1="68.09" y1="658.2" x2="102.45" y2="673.9" />
      <path
        class="cls-3"
        d="M91.62,660.24a28.28,28.28,0,0,1,10.33.12,38.55,38.55,0,0,1,9.07,2.88,37.47,37.47,0,0,1,8.12,5A27.83,27.83,0,0,1,126,676a28.13,28.13,0,0,1-10.34-.11,38.17,38.17,0,0,1-9.06-2.89,38.92,38.92,0,0,1-8.11-5A28.41,28.41,0,0,1,91.62,660.24Z"
        transform="translate(-23.54 -2.05)"
      />
      <line class="cls-1" x1="54.05" y1="695.63" x2="89.43" y2="708.89" />
      <path
        class="cls-3"
        d="M77.59,697.67a28.21,28.21,0,0,1,10.31-.61,39.08,39.08,0,0,1,9.25,2.24,38.14,38.14,0,0,1,8.45,4.38,27.9,27.9,0,0,1,7.36,7.25,27.84,27.84,0,0,1-10.32.62,38.18,38.18,0,0,1-9.24-2.25A38.77,38.77,0,0,1,85,704.91,28.19,28.19,0,0,1,77.59,697.67Z"
        transform="translate(-23.54 -2.05)"
      />
      <line class="cls-1" x1="45.1" y1="740.07" x2="82.17" y2="747.34" />
      <path
        class="cls-3"
        d="M68.63,742.11a28.27,28.27,0,0,1,10.08-2.29,39.58,39.58,0,0,1,18.53,3.62,28,28,0,0,1,8.46,5.95,28.1,28.1,0,0,1-10.08,2.31,38.33,38.33,0,0,1-9.48-.71,38.93,38.93,0,0,1-9-3A28.18,28.18,0,0,1,68.63,742.11Z"
        transform="translate(-23.54 -2.05)"
      />
      <line class="cls-1" x1="40.9" y1="781.45" x2="78.62" y2="783.69" />
      <path
        class="cls-3"
        d="M64.44,783.5a28.35,28.35,0,0,1,9.68-3.62,38.52,38.52,0,0,1,9.49-.59A37.94,37.94,0,0,1,93,781a28,28,0,0,1,9.18,4.76,27.92,27.92,0,0,1-9.67,3.63A38.11,38.11,0,0,1,83,790a39.11,39.11,0,0,1-9.36-1.71A28.17,28.17,0,0,1,64.44,783.5Z"
        transform="translate(-23.54 -2.05)"
      />
      <path
        class="cls-1"
        d="M735.25,829.42l56,9.47c2.72-36.37,1.69-94.48-24.11-157.56-18.22-44.55-41.45-73.59-48.21-81.79a305,305,0,0,0-80.54-68.67l-45.31,36.76c26.53,14.17,64.44,39.53,95.71,82.71a260.73,260.73,0,0,1,34.44,64.57A250,250,0,0,1,735.25,829.42Z"
        transform="translate(-23.54 -2.05)"
      />
      <path
        class="cls-2"
        d="M735.62,829.15l28.5,3.55L778,834.46l13.67,1.87-3,2.36a390.11,390.11,0,0,0-5.88-89.36c-.76-3.66-1.45-7.32-2.25-11s-1.62-7.28-2.51-10.9-1.87-7.23-2.87-10.82L772,705.88c-1.16-3.55-2.36-7.08-3.48-10.65s-2.52-7-3.77-10.55c-.61-1.77-1.32-3.5-2-5.24l-2-5.23c-1.49-3.43-2.86-6.92-4.44-10.31-12.21-27.34-28.21-53.31-48.75-75.3a273.94,273.94,0,0,0-33.18-30.44,298.68,298.68,0,0,0-37.52-24.7l3.41-.26-11.1,9.47L618,552.08c-7.43,6.28-14.93,12.47-22.39,18.7l-.64-6.73A307.59,307.59,0,0,1,629.29,585a292.49,292.49,0,0,1,31.12,25.56,266,266,0,0,1,27,30,275.83,275.83,0,0,1,22,33.73A254,254,0,0,1,725.94,711a238.8,238.8,0,0,1,13.19,78.83q0,10-.88,19.94l-.47,5-.58,4.95-.71,4.93C736.26,826.09,735.93,827.53,735.62,829.15Zm-.73.54c.06-1.67.13-3.51.26-5.27l.25-4.94.18-4.93.08-4.94c0-6.58-.08-13.15-.52-19.7s-1-13.07-2-19.54-2-12.92-3.38-19.31a257,257,0,0,0-11.21-37.39,252.54,252.54,0,0,0-17-35,281.88,281.88,0,0,0-47.78-61.23,288.48,288.48,0,0,0-29.72-25.21,298.81,298.81,0,0,0-32.92-21l-.09-.05a4,4,0,0,1-.55-6.68c7.64-6,15.24-12.08,22.91-18.05l11.51-9,11.55-8.91.11-.1a2.91,2.91,0,0,1,3.3-.16,332.71,332.71,0,0,1,69.7,58.43c2.52,2.83,5.07,5.64,7.48,8.57s4.92,5.77,7.27,8.76,4.63,6,6.87,9.08,4.46,6.14,6.61,9.27a372.69,372.69,0,0,1,23.48,39.08c1.8,3.36,3.39,6.82,5.09,10.23s3.25,6.91,4.68,10.44,3,7,4.34,10.6,2.6,7.18,3.9,10.77l3.49,10.92c1,3.68,2,7.38,3,11.06s1.75,7.44,2.62,11.16,1.44,7.51,2.16,11.26,1.19,7.54,1.79,11.31,1,7.58,1.39,11.37c.74,7.6,1.3,15.21,1.55,22.84a332.62,332.62,0,0,1-1.49,45.64l0,.14a2.53,2.53,0,0,1-2.76,2.27l-.25,0-14.31-2.87-14.12-3Z"
        transform="translate(-23.54 -2.05)"
      />
      <path
        class="cls-4"
        d="M818.77,910.35c-3.9,6.78-36.72.52-37,0,.69-3.08,4.43-21-6.89-36.16a40.91,40.91,0,0,0-14.64-12.06,30.86,30.86,0,0,0-18.94,1.73c-12.36,5.59-20,20.31-18.94,37-.61.51-35.83-9.32-36.16-10.33.33-2.48,7.29-49.18,43.91-63.72a64.57,64.57,0,0,1,33.58-3.44c6.65,1.55,25.81,6.94,40.46,25C825.41,874.54,819.67,905.83,818.77,910.35Z"
        transform="translate(-23.54 -2.05)"
      />
      <path
        class="cls-2"
        d="M819.19,910.51c-.94,1.81-2.64,2.5-4.2,3.08a25.69,25.69,0,0,1-4.85,1.08,65,65,0,0,1-9.74.5c-3.24,0-6.46-.25-9.68-.54-1.61-.15-3.21-.32-4.82-.53-.81-.09-1.62-.23-2.43-.36l-1.25-.23c-.21,0-.44-.09-.68-.14l-.18,0-.26-.08-.26-.08a3.59,3.59,0,0,1-.38-.17,3.84,3.84,0,0,1-.5-.32,3.64,3.64,0,0,1-.77-.86,2.69,2.69,0,0,1-.37-1.88l0-.24a48.93,48.93,0,0,0,.41-13.29A40.84,40.84,0,0,0,776,883.83a34.72,34.72,0,0,0-3.14-5.59,32.15,32.15,0,0,0-4-5,40.66,40.66,0,0,0-10.37-7.55l1,.34a29.92,29.92,0,0,0-13.83,0,26,26,0,0,0-12,7.06,32.93,32.93,0,0,0-4.47,5.82,34.17,34.17,0,0,0-3.14,6.8,18.86,18.86,0,0,0-.58,1.8c-.16.61-.36,1.22-.5,1.83-.25,1.25-.56,2.49-.69,3.76a44.45,44.45,0,0,0-.39,7.66v.11a1.39,1.39,0,0,1-.52,1.1,1.58,1.58,0,0,1-.53.28l-.29.07h-.3l-.27,0-.36-.06-.64-.12-1.18-.28-2.31-.59-4.57-1.21-9.12-2.46-9.11-2.51c-1.52-.42-3-.85-4.55-1.3l-2.3-.7-1.18-.39c-.2-.08-.41-.15-.63-.25l-.39-.18-.13-.07a1.34,1.34,0,0,1-.17-.11l-.23-.17a2.08,2.08,0,0,1-.55-.83h0a2.15,2.15,0,0,1-.08-.79c.28-2.51.7-4.88,1.17-7.29s1-4.78,1.62-7.15a112.45,112.45,0,0,1,4.63-14,77.3,77.3,0,0,1,16.1-25.17,63.88,63.88,0,0,1,12-9.59,61.67,61.67,0,0,1,14-6.4,69,69,0,0,1,7.5-1.85,68.3,68.3,0,0,1,23-.25h0l.33.06c2.46.59,4.91,1.28,7.3,2.1s4.74,1.75,7,2.82a76.92,76.92,0,0,1,13.08,7.59,72.29,72.29,0,0,1,20.06,22.28c.62,1.1,1.25,2.18,1.84,3.27l1.58,3.41.78,1.7c.24.57.43,1.17.65,1.75l1.25,3.51a74.82,74.82,0,0,1,3.07,14.46,79.34,79.34,0,0,1,.28,14.61c-.18,2.42-.48,4.83-.88,7.21-.19,1.19-.42,2.37-.7,3.55S819.55,909.25,819.19,910.51Zm-.84-.32c.09-1.08.21-2.29.26-3.46s.1-2.36.13-3.54,0-2.35,0-3.52-.11-2.35-.15-3.51a90.43,90.43,0,0,0-1.93-13.8l-.82-3.36-1-3.3c-.17-.54-.32-1.1-.5-1.64l-.61-1.6c-.41-1.07-.79-2.14-1.23-3.19l-1.44-3.09c-.24-.51-.46-1-.73-1.54l-.83-1.48-1.63-3L806,857.38a53.37,53.37,0,0,0-4.06-5.38c-.35-.44-.68-.89-1.06-1.31l-1.13-1.24c-.76-.83-1.5-1.67-2.32-2.43A66.17,66.17,0,0,0,787,838.59a75.9,75.9,0,0,0-24.45-10.49l.36.07a69.26,69.26,0,0,0-13.33-.74,63.62,63.62,0,0,0-6.62.62,61.88,61.88,0,0,0-6.49,1.39,54.44,54.44,0,0,0-23,13c-6.6,6.12-11.87,13.77-16.22,22a104.81,104.81,0,0,0-5.59,12.85A87.92,87.92,0,0,0,688,890.78l-.07-.8a1.6,1.6,0,0,0-.2-.42,1.64,1.64,0,0,0-.26-.29l-.11-.09-.05,0h0l.14.07.45.21c.33.15.68.29,1,.43.71.28,1.44.54,2.17.79,1.47.52,3,1,4.44,1.49l4.47,1.44,4.51,1.32c3,.87,6,1.76,9,2.53,1.51.4,3,.79,4.54,1.15l2.27.51,1.12.22.53.09.21,0h-.09l-.25,0a1.38,1.38,0,0,0-.46.26l-.52,1.22a52,52,0,0,1,1.24-16.36,40.06,40.06,0,0,1,7.22-15.17,33.12,33.12,0,0,1,6.26-6.08c.6-.42,1.21-.85,1.83-1.26l1.94-1.09a27.72,27.72,0,0,1,4.11-1.78,33.55,33.55,0,0,1,17.56-1,3.85,3.85,0,0,1,.85.28l.11,0a42.65,42.65,0,0,1,12.59,9.16,38.45,38.45,0,0,1,4.83,6.19,42.1,42.1,0,0,1,3.62,7,45.48,45.48,0,0,1,3.19,15.08,51.43,51.43,0,0,1-1.6,15.08l-.33-2.12a2.38,2.38,0,0,0-.64-.79,2.32,2.32,0,0,0-.43-.29,3.31,3.31,0,0,0-.31-.14h0l0,0,.1,0,.48.14,1.08.29,2.24.53c1.52.36,3,.69,4.58,1,3.06.63,6.15,1.12,9.24,1.59a81.14,81.14,0,0,0,9.29.83,27.53,27.53,0,0,0,4.56-.26,10.65,10.65,0,0,0,2.14-.54A5,5,0,0,0,818.35,910.19Z"
        transform="translate(-23.54 -2.05)"
      />
      <line class="cls-1" x1="658.64" y1="568.24" x2="634.95" y2="597.66" />
      <path
        class="cls-3"
        d="M682.18,570.29a28.46,28.46,0,0,1-2.66,10,38.6,38.6,0,0,1-5,8.08,37.94,37.94,0,0,1-6.81,6.64,28,28,0,0,1-9.19,4.72,28,28,0,0,1,2.64-10,38.72,38.72,0,0,1,5-8.07A39.38,39.38,0,0,1,673,575,28.37,28.37,0,0,1,682.18,570.29Z"
        transform="translate(-23.54 -2.05)"
      />
      <line class="cls-1" x1="686.91" y1="595.04" x2="658.71" y2="620.18" />
      <path
        class="cls-3"
        d="M710.44,597.09a28.15,28.15,0,0,1-4.26,9.41,38.78,38.78,0,0,1-6.28,7.14,38.12,38.12,0,0,1-7.81,5.44,27.9,27.9,0,0,1-9.85,3.15,28.17,28.17,0,0,1,4.26-9.43,39.43,39.43,0,0,1,14.11-12.55A28.14,28.14,0,0,1,710.44,597.09Z"
        transform="translate(-23.54 -2.05)"
      />
      <line class="cls-1" x1="713.08" y1="631.67" x2="681.76" y2="652.8" />
      <path
        class="cls-3"
        d="M736.62,633.71a28.28,28.28,0,0,1-5.49,8.76,39.89,39.89,0,0,1-15.65,10.58,28.07,28.07,0,0,1-10.18,1.79,27.94,27.94,0,0,1,5.48-8.77,38.11,38.11,0,0,1,7.19-6.22,39.09,39.09,0,0,1,8.47-4.33A28.32,28.32,0,0,1,736.62,633.71Z"
        transform="translate(-23.54 -2.05)"
      />
      <line class="cls-1" x1="730.27" y1="665.03" x2="695.91" y2="680.73" />
      <path
        class="cls-3"
        d="M753.81,667.07a28.41,28.41,0,0,1-6.85,7.74,39,39,0,0,1-8.12,5,37.89,37.89,0,0,1-9.06,2.89,27.87,27.87,0,0,1-10.33.1,27.93,27.93,0,0,1,6.84-7.74,37.47,37.47,0,0,1,8.12-5,38.47,38.47,0,0,1,9.06-2.88A28.33,28.33,0,0,1,753.81,667.07Z"
        transform="translate(-23.54 -2.05)"
      />
      <line class="cls-1" x1="744.3" y1="702.45" x2="708.93" y2="715.72" />
      <path
        class="cls-3"
        d="M767.84,704.5a28.22,28.22,0,0,1-7.38,7.24,39.48,39.48,0,0,1-17.68,6.64,27.86,27.86,0,0,1-10.32-.62,27.93,27.93,0,0,1,7.37-7.25,38.14,38.14,0,0,1,8.45-4.38,39.12,39.12,0,0,1,9.24-2.24A28.26,28.26,0,0,1,767.84,704.5Z"
        transform="translate(-23.54 -2.05)"
      />
      <line class="cls-1" x1="753.26" y1="746.9" x2="716.19" y2="754.17" />
      <path
        class="cls-3"
        d="M776.8,748.94a28.36,28.36,0,0,1-8.46,5.93,38.93,38.93,0,0,1-9.05,3,38.37,38.37,0,0,1-9.49.71,28.1,28.1,0,0,1-10.07-2.31,28.1,28.1,0,0,1,8.45-6,38.87,38.87,0,0,1,9.05-2.93,38.4,38.4,0,0,1,9.49-.69A28.32,28.32,0,0,1,776.8,748.94Z"
        transform="translate(-23.54 -2.05)"
      />
      <line class="cls-1" x1="757.45" y1="788.28" x2="719.74" y2="790.52" />
      <path
        class="cls-3"
        d="M781,790.33a28.36,28.36,0,0,1-9.18,4.74,39.11,39.11,0,0,1-9.36,1.71,38.08,38.08,0,0,1-9.5-.58,28,28,0,0,1-9.68-3.63,28,28,0,0,1,9.18-4.76,38.11,38.11,0,0,1,9.36-1.69,38.57,38.57,0,0,1,9.5.59A28.22,28.22,0,0,1,781,790.33Z"
        transform="translate(-23.54 -2.05)"
      />
      <path
        class="cls-5"
        d="M634,925.65a1704.44,1704.44,0,0,1-206.36,13.44,1704.2,1704.2,0,0,1-221.18-13.44,1788,1788,0,0,1,0-427.54,1407,1407,0,0,1,427.54,0A1753.36,1753.36,0,0,1,646.7,673.82,1754.81,1754.81,0,0,1,634,925.65Z"
        transform="translate(-23.54 -2.05)"
      />
      <path
        class="cls-2"
        d="M634.34,926,627.61,927c-2.24.34-4.62.71-6.79,1-4.43.61-8.85,1.27-13.28,1.82-8.87,1.14-17.74,2.26-26.62,3.24-17.77,2-35.58,3.7-53.42,5q-13.38,1-26.77,1.83t-26.8,1.33c-17.88.73-35.78,1.21-53.67,1.3s-35.8,0-53.7-.5-35.78-1.3-53.65-2.37-35.72-2.48-53.54-4.2-35.61-3.81-53.35-6.14H206a3.7,3.7,0,0,1-3.2-3.26q-6-53.36-8.38-107c-.82-17.87-1.44-35.74-1.76-53.61s-.5-35.75-.41-53.62q.17-53.61,3.13-107.17.74-13.38,1.66-26.76c.6-8.91,1.22-17.83,2-26.74q2.14-26.73,5.08-53.39a2.43,2.43,0,0,1,2-2.13h.05c35.36-5.81,70.94-10.4,106.68-13.39s71.59-4.61,107.47-4.72,71.76,1.06,107.55,3.63q26.85,1.91,53.59,5c17.83,2.06,35.62,4.4,53.35,7.16h0a4.78,4.78,0,0,1,4,4.16c4.21,35.56,7.45,71.24,9.4,107q1.45,26.82,2.11,53.66c.41,17.9.47,35.8.34,53.69s-.66,35.78-1.39,53.66c-.35,8.94-.83,17.87-1.32,26.8l-.85,13.38-1,13.38c-1.32,17.84-3,35.64-4.94,53.41q-1.45,13.34-3.11,26.63l-1.74,13.31Zm-.63-.64,2.38-26.4c.79-8.89,1.54-17.78,2.19-26.68,1.33-17.8,2.37-35.61,3.24-53.43q2.54-53.45,2-106.94t-4.07-106.82q-1.85-26.65-4.33-53.26t-5.89-53.1l4,4.15c-17.63-2.65-35.29-5.07-53-7.11s-35.45-3.72-53.22-5.19q-53.3-4.29-106.83-4.52c-35.66-.18-71.33,1.07-106.92,3.46q-26.7,1.8-53.33,4.53t-53.15,6.52l2.07-2.13q-3.45,26.52-6.11,53.15c-.46,4.44-.88,8.88-1.29,13.32s-.8,8.88-1.17,13.33q-1.1,13.34-2,26.69-3.5,53.4-3.26,107,.12,26.76,1.18,53.51t3,53.42c2.62,35.57,6.31,71,10.86,106.39L207,921.93c17.69,2.13,35.43,3.91,53.16,5.6s35.51,3,53.29,4.23,35.58,2.08,53.39,2.68,35.63,1.06,53.46,1.17,35.65,0,53.48-.37c8.91-.19,17.82-.47,26.73-.78s17.82-.67,26.73-1.12c17.81-.91,35.63-2,53.42-3.39q13.35-1,26.68-2.21Z"
        transform="translate(-23.54 -2.05)"
      />
      <path
        class="cls-4"
        d="M640.21,1164.1c-70.63,5.2-146.18,8.15-226.14,7.76-69.49-.34-135.57-3.17-197.9-7.76A77.81,77.81,0,0,1,160,1139a88.72,88.72,0,0,1-23.26-60.5v-17.09c0-47.26,35.55-85.56,79.4-85.56,67.45,6.19,140.88,10,219.51,9.7,72.94-.24,141.32-3.9,204.53-9.7A77.83,77.83,0,0,1,696.36,1001a88.76,88.76,0,0,1,23.25,60.5v17.09C719.61,1125.79,684.06,1164.1,640.21,1164.1Z"
        transform="translate(-23.54 -2.05)"
      />
      <path
        class="cls-2"
        d="M640.23,1164.55c-17.61,1.32-35.28,2.46-52.92,3.67l-26.49,1.64q-13.23.83-26.49,1.54c-35.34,2-70.72,3.47-106.14,4q-13.28.15-26.56.21t-26.56-.18c-17.71-.23-35.41-.82-53.11-1.48-35.38-1.5-70.72-4-106-7.13h.2a77.47,77.47,0,0,1-17.66-2.49,80.75,80.75,0,0,1-16.58-6.28,84,84,0,0,1-14.78-9.72l-3.31-2.93a19.09,19.09,0,0,1-1.59-1.53l-1.54-1.58c-1-1-2.08-2.08-3-3.21l-1.44-1.67c-.48-.56-.92-1.14-1.38-1.72A90.42,90.42,0,0,1,139,1104.56a91.74,91.74,0,0,1-3.21-17.21l-.3-4.38-.09-4.38,0-8.63,0-8.63.1-4.38.3-4.37a91.65,91.65,0,0,1,3.24-17.21A89.6,89.6,0,0,1,155,1004.3a82.51,82.51,0,0,1,27-22.36,77.21,77.21,0,0,1,34.21-8.52h.23c35.24,2.75,70.54,4.63,105.85,6s70.62,2,105.94,1.78,70.63-1.23,105.9-2.8l13.23-.65,13.22-.73q13.23-.69,26.44-1.55,26.43-1.7,52.82-4h.09l.32,0a79.25,79.25,0,0,1,18.1,2.44,81.21,81.21,0,0,1,17,6.33,84.2,84.2,0,0,1,15.13,10l3.39,3a20.14,20.14,0,0,1,1.63,1.57l1.57,1.62c1.05,1.08,2.12,2.14,3.07,3.3l1.47,1.71c.48.58.93,1.18,1.39,1.77a90.36,90.36,0,0,1,15.8,31.89,93.18,93.18,0,0,1,3,17.51L722,1057v4.43l-.17,8.64-.18,8.63-.2,4.4-.4,4.39a94.58,94.58,0,0,1-3.62,17.18,89.84,89.84,0,0,1-16.54,30.61,83.77,83.77,0,0,1-12.4,12.22,81.43,81.43,0,0,1-14.69,9.29A75.5,75.5,0,0,1,640.23,1164.55Zm0-.9a74.35,74.35,0,0,0,33-8,78.43,78.43,0,0,0,26.15-21.63,85.25,85.25,0,0,0,15.14-30.26,86.72,86.72,0,0,0,2.84-16.68l.21-4.23v-4.22l-.18-8.63-.18-8.64-.18-4.2-.39-4.18a87.37,87.37,0,0,0-3.46-16.36,84.78,84.78,0,0,0-15.84-29c-.44-.53-.87-1.07-1.33-1.58l-1.39-1.53c-.9-1-1.91-2-2.9-2.93l-1.48-1.43a18.18,18.18,0,0,0-1.52-1.38l-3.15-2.63a78.41,78.41,0,0,0-13.91-8.58,72.83,72.83,0,0,0-15.39-5.39,70.31,70.31,0,0,0-16.08-1.86l.41,0c-17.64,1.73-35.31,3.19-53,4.49q-13.26,1-26.54,1.79l-13.27.71-13.29.64c-35.42,1.67-70.89,2.24-106.34,2s-70.9-1.13-106.29-3-70.72-4.9-105.95-8.62h.22a72.51,72.51,0,0,0-32.38,7.26,77.58,77.58,0,0,0-26.25,20.77,85.77,85.77,0,0,0-15.75,29.79,89.28,89.28,0,0,0-3.22,16.67l-.31,4.24-.11,4.25,0,8.63,0,8.63.11,4.25.31,4.24a89.78,89.78,0,0,0,3.22,16.67,84.76,84.76,0,0,0,15.77,29.76c.45.54.88,1.1,1.34,1.63l1.42,1.57c.92,1.07,1.94,2,3,3l1.51,1.47a19,19,0,0,0,1.56,1.42l3.23,2.7a79.48,79.48,0,0,0,14.26,8.83,74.85,74.85,0,0,0,32.34,7.25h.2q52.94,3,105.89,4.56c17.65.64,35.3,1,53,1.45l26.48.55q13.24.29,26.49.45c35.33.49,70.68.68,106,.07q13.26-.27,26.51-.65c8.84-.27,17.67-.66,26.5-1C604.9,1166.06,622.53,1164.93,640.2,1163.65Z"
        transform="translate(-23.54 -2.05)"
      />
      <circle class="cls-1" cx="227.53" cy="1069.27" r="73.11" />
      <path
        class="cls-2"
        d="M324.62,1071.32a85.45,85.45,0,0,1-4.94,28.42c-.4,1.15-.88,2.27-1.31,3.41s-1,2.23-1.48,3.35-1.08,2.2-1.62,3.3-1.19,2.15-1.78,3.23a75.83,75.83,0,0,1-8.7,12,69.19,69.19,0,0,1-24.22,17.51,69.94,69.94,0,0,1-29.51,5.63,73.73,73.73,0,0,1-14.88-2,75.69,75.69,0,0,1-14.05-5,82.67,82.67,0,0,1-40-41.28c-.46-1.13-1-2.25-1.38-3.39s-.86-2.3-1.23-3.46-.76-2.33-1.08-3.51-.66-2.37-.92-3.57a79.85,79.85,0,0,1-2-14.63,73.4,73.4,0,0,1,20.86-54.71,77,77,0,0,1,24.92-17.19,74.53,74.53,0,0,1,59.43.32c1.17.5,2.29,1.1,3.43,1.64s2.23,1.22,3.34,1.82,2.14,1.34,3.21,2,2.07,1.45,3.1,2.17a70.17,70.17,0,0,1,11.08,10.13,75.63,75.63,0,0,1,8.69,12c.6,1.08,1.22,2.14,1.78,3.23s1.11,2.19,1.62,3.31,1,2.22,1.48,3.35.91,2.26,1.31,3.42A84.55,84.55,0,0,1,324.62,1071.32Zm-.9,0a64.28,64.28,0,0,0-6.24-27.51,68.14,68.14,0,0,0-16.84-22.07,76.67,76.67,0,0,0-11.07-8.06c-1-.56-2-1.15-3-1.68s-2-1-3-1.53-2-1-3.07-1.41-2.08-.87-3.14-1.27a72.29,72.29,0,0,0-52.48.32,69.83,69.83,0,0,0-22.51,14.52,72.23,72.23,0,0,0-15.53,22.09,75.44,75.44,0,0,0-4.48,12.93,71.05,71.05,0,0,0-2,13.67,66.7,66.7,0,0,0,4.51,27.39A65.13,65.13,0,0,0,224,1136.57a73.53,73.53,0,0,0,27,4.1A79.08,79.08,0,0,0,300.73,1121a68.92,68.92,0,0,0,16.82-22.13A63.64,63.64,0,0,0,323.72,1071.32Z"
        transform="translate(-23.54 -2.05)"
      />
      <circle class="cls-1" cx="407.24" cy="1077.41" r="73.11" />
      <path
        class="cls-2"
        d="M504.33,1079.46a85.41,85.41,0,0,1-4.94,28.42c-.4,1.15-.88,2.27-1.31,3.41s-1,2.23-1.48,3.35-1.08,2.2-1.62,3.3-1.19,2.15-1.78,3.23a75.83,75.83,0,0,1-8.7,12,69.19,69.19,0,0,1-24.22,17.51,69.92,69.92,0,0,1-29.5,5.63,73.73,73.73,0,0,1-14.89-2,75,75,0,0,1-14.05-5,82.67,82.67,0,0,1-40-41.28c-.46-1.13-1-2.24-1.38-3.39s-.86-2.29-1.23-3.46-.76-2.33-1.08-3.51-.66-2.37-.92-3.57a79.85,79.85,0,0,1-2-14.63,73.36,73.36,0,0,1,20.86-54.7,76.88,76.88,0,0,1,24.92-17.2,74.53,74.53,0,0,1,59.43.32c1.17.5,2.29,1.1,3.43,1.64s2.23,1.22,3.34,1.82,2.14,1.35,3.21,2,2.07,1.45,3.1,2.17a70.17,70.17,0,0,1,11.08,10.13,75.63,75.63,0,0,1,8.69,12c.6,1.08,1.22,2.14,1.78,3.23s1.11,2.19,1.62,3.31,1,2.22,1.48,3.35.91,2.27,1.31,3.42A84.55,84.55,0,0,1,504.33,1079.46Zm-.9,0a64.28,64.28,0,0,0-6.24-27.51,68.14,68.14,0,0,0-16.84-22.07,76.67,76.67,0,0,0-11.07-8.06c-1-.56-2-1.14-3-1.68s-2-1-3-1.53-2-1-3.07-1.41-2.08-.87-3.14-1.27a72.3,72.3,0,0,0-52.48.32,69.83,69.83,0,0,0-22.51,14.52,72.23,72.23,0,0,0-15.53,22.09,75.44,75.44,0,0,0-4.48,12.93,71.05,71.05,0,0,0-1.95,13.67,66.7,66.7,0,0,0,4.51,27.39,65.13,65.13,0,0,0,39.11,37.86,73.55,73.55,0,0,0,27,4.1,79.07,79.07,0,0,0,49.66-19.69A68.82,68.82,0,0,0,497.26,1107,63.64,63.64,0,0,0,503.43,1079.46Z"
        transform="translate(-23.54 -2.05)"
      />
      <circle class="cls-1" cx="580.63" cy="1069.34" r="73.11" />
      <path
        class="cls-2"
        d="M677.73,1071.38a85.67,85.67,0,0,1-4.94,28.42c-.4,1.15-.88,2.27-1.32,3.41s-1,2.23-1.48,3.35-1.07,2.2-1.61,3.31-1.19,2.14-1.78,3.22a74.82,74.82,0,0,1-8.71,12,69,69,0,0,1-53.72,23.14,73,73,0,0,1-14.88-2,74.72,74.72,0,0,1-14-5,82.7,82.7,0,0,1-40-41.27c-.46-1.13-1-2.25-1.39-3.4s-.86-2.29-1.22-3.46-.77-2.33-1.09-3.51-.65-2.37-.92-3.56a79.84,79.84,0,0,1-2-14.64,73.46,73.46,0,0,1,20.87-54.7,76.59,76.59,0,0,1,24.92-17.19,74.58,74.58,0,0,1,59.43.31c1.17.5,2.29,1.1,3.43,1.65s2.22,1.21,3.33,1.82,2.15,1.34,3.21,2,2.07,1.44,3.11,2.16A71.6,71.6,0,0,1,658,1017.57a76.55,76.55,0,0,1,8.69,12c.59,1.08,1.21,2.14,1.78,3.23s1.11,2.19,1.61,3.31,1,2.22,1.48,3.36.92,2.26,1.31,3.41A84.31,84.31,0,0,1,677.73,1071.38Zm-.9,0a64.34,64.34,0,0,0-6.24-27.51,68.39,68.39,0,0,0-16.84-22.07,77.23,77.23,0,0,0-11.07-8.06c-1-.55-2-1.14-3-1.67s-2-1.05-3-1.53-2-1-3.08-1.41-2.08-.87-3.13-1.27a71.84,71.84,0,0,0-26.31-4.78,72.68,72.68,0,0,0-26.18,5.1,69.87,69.87,0,0,0-22.5,14.51,72.22,72.22,0,0,0-15.53,22.1,74.49,74.49,0,0,0-4.48,12.92,71.17,71.17,0,0,0-2,13.67,66.81,66.81,0,0,0,4.5,27.39,65.11,65.11,0,0,0,39.11,37.87,73.4,73.4,0,0,0,27,4.09,79.17,79.17,0,0,0,49.67-19.68,69,69,0,0,0,16.81-22.13A63.58,63.58,0,0,0,676.83,1071.38Z"
        transform="translate(-23.54 -2.05)"
      />
      <rect
        class="cls-7"
        x="213.18"
        y="527.32"
        width="367.45"
        height="367.45"
        rx="78.07"
      />
      <path
        class="cls-2"
        d="M526.1,897.44q-41.75,0-83.49,1l-20.87.51-20.87.61-41.75,1.24c-13.91.35-27.82.76-41.74,1l-2.61.06-2.77,0c-1.86,0-3.7-.17-5.55-.27a83.53,83.53,0,0,1-11-1.7c-1.82-.36-3.6-.92-5.4-1.39l-2.65-.87-1.32-.43-1.31-.5A80.7,80.7,0,0,1,274.61,892a82.79,82.79,0,0,1-31.78-30.67,81.91,81.91,0,0,1-11.29-42.62c.81-55.66,2.8-111.32,3.18-167,.1-13.92.16-27.83.11-41.75v-2.61l.06-2.67c0-1.78.21-3.55.32-5.33A79.9,79.9,0,0,1,237,588.88c.35-1.75.91-3.45,1.37-5.17l.85-2.54.42-1.27.48-1.25a79.88,79.88,0,0,1,4.41-9.76,87.3,87.3,0,0,1,5.69-9.08,80.66,80.66,0,0,1,6.86-8.25l.92-1,.95-.94,1.93-1.88c1.34-1.18,2.64-2.42,4.06-3.52a79.69,79.69,0,0,1,8.78-6.24,81.68,81.68,0,0,1,41.12-12l41.75-.84,20.87-.41,20.87-.33c27.83-.43,55.66-.65,83.49-.89l41.74-.34,2.61,0,2.81.05c1.88,0,3.75.21,5.63.32a85.61,85.61,0,0,1,11.12,1.82c1.85.37,3.64.95,5.46,1.43l2.68.89,1.34.44,1.32.51a84,84,0,0,1,54.32,78.84q-.16,41.74-.61,83.49l-.33,20.87-.46,20.87c-.27,13.92-.72,27.83-1.1,41.75L607,816.16l-.08,2.61-.14,2.7c-.06,1.79-.33,3.58-.5,5.36a81.7,81.7,0,0,1-2.1,10.55c-.42,1.74-1,3.43-1.52,5.14l-.92,2.52-.46,1.25-.52,1.24a80.92,80.92,0,0,1-4.72,9.57,82,82,0,0,1-29.71,29.61,87.26,87.26,0,0,1-9.45,4.67,81.24,81.24,0,0,1-30.79,6.06Zm0-1.24a81,81,0,0,0,10.32-.74c1.71-.18,3.4-.57,5.1-.86L544,894c.84-.19,1.67-.39,2.5-.65a78.14,78.14,0,0,0,9.73-3.46,77,77,0,0,0,9.14-4.77,75.47,75.47,0,0,0,27.67-29.67,76.49,76.49,0,0,0,4-9.35l.44-1.19.37-1.22.75-2.42c.4-1.65.91-3.27,1.19-4.94a78.9,78.9,0,0,0,1.39-10c0-1.68.21-3.36.15-5v-2.52l-.08-2.61L600,774.42c-.38-13.92-.83-27.83-1.1-41.75l-.46-20.87-.32-20.87q-.51-41.74-.62-83.49a71.85,71.85,0,0,0-10-36.37,71.78,71.78,0,0,0-35.68-30.49l-1.11-.45-1.13-.39-2.26-.78c-1.54-.42-3.05-1-4.62-1.28a75,75,0,0,0-9.43-1.67c-1.6-.1-3.19-.32-4.79-.33l-2.4-.08-2.61,0-41.74-.34c-27.83-.23-55.66-.46-83.49-.89L377.41,534l-20.87-.41-41.75-.84a74.42,74.42,0,0,0-38.43,9.76,72.49,72.49,0,0,0-8.4,5.59c-1.37,1-2.62,2.12-3.93,3.19L262.17,553c-.63.56-1.24,1.15-1.81,1.76a76.64,76.64,0,0,0-6.63,7.66,80.86,80.86,0,0,0-5.56,8.48,73.11,73.11,0,0,0-7.41,18.86,77.15,77.15,0,0,0-1.73,10c-.11,1.69-.33,3.38-.34,5.08l-.07,2.54V610c-.06,13.92,0,27.83.11,41.75.38,55.65,2.37,111.31,3.18,167a74.15,74.15,0,0,0,38,63.64,73.18,73.18,0,0,0,18,7.14,75.39,75.39,0,0,0,9.57,1.79c1.62.12,3.23.36,4.86.38l2.44.11,2.61.05c13.92.25,27.83.66,41.74,1l41.75,1.23,20.87.62,20.87.51Q484.36,896.26,526.1,896.2Z"
        transform="translate(-23.54 -2.05)"
      />
      <path
        class="cls-8"
        d="M593.05,594.54C604.21,674.31,385.2,906.6,299.67,887.92c-30.76-6.71-44.22-25.61-44.22-25.61s-11.43-16-10.64-39.75c1.64-49,72.68-71.25,145.45-142.32,73.26-71.54,99.18-144.59,145.46-142.34a65.88,65.88,0,0,1,36.7,13.3S589,565.25,593.05,594.54Z"
        transform="translate(-23.54 -2.05)"
      />
      <ellipse
        class="cls-2"
        cx="324.11"
        cy="260.37"
        rx="31.83"
        ry="42.48"
        transform="translate(-57.69 47.41) rotate(-8.29)"
      />
      <ellipse
        class="cls-2"
        cx="490.41"
        cy="236.14"
        rx="31.83"
        ry="42.48"
        transform="translate(-52.46 71.13) rotate(-8.29)"
      />
      <ellipse
        class="cls-6"
        cx="312.09"
        cy="246.78"
        rx="14.27"
        ry="19.69"
        transform="translate(-55.86 45.53) rotate(-8.29)"
      />
      <ellipse
        class="cls-6"
        cx="479.01"
        cy="223.1"
        rx="14.27"
        ry="19.69"
        transform="translate(-50.7 69.35) rotate(-8.29)"
      />
      <path
        class="cls-2"
        d="M490.2,312.21a51.38,51.38,0,0,1-4.6,8,70.32,70.32,0,0,1-5.75,7.27,80.4,80.4,0,0,1-14.09,12.28,84.09,84.09,0,0,1-73,10.79,77.77,77.77,0,0,1-17-7.82c-1.33-.8-2.61-1.69-3.88-2.57s-2.49-1.81-3.67-2.82a51.64,51.64,0,0,1-6.64-6.42l-.1-.11a.49.49,0,0,1,.05-.7.5.5,0,0,1,.58-.06,100.91,100.91,0,0,0,15.7,7.59,102.32,102.32,0,0,0,16.67,5,97.15,97.15,0,0,0,34.59.94,99.28,99.28,0,0,0,32.83-10.93,108.33,108.33,0,0,0,14.61-9.48,103.68,103.68,0,0,0,13-11.63.5.5,0,0,1,.81.55Z"
        transform="translate(-23.54 -2.05)"
      />
      <circle class="cls-4" cx="584.4" cy="1070.07" r="41.55" />
      <path
        class="cls-2"
        d="M649.87,1072.12a53.14,53.14,0,0,1-2.64,16.28,45.25,45.25,0,0,1-8.18,14.83,38.49,38.49,0,0,1-13.91,10.42,39,39,0,0,1-17.2,3.22,41.67,41.67,0,0,1-16.71-4.41,49.58,49.58,0,0,1-13.55-10.08,48.3,48.3,0,0,1-13.39-30.26,42,42,0,0,1,11.7-31.95A44.56,44.56,0,0,1,590.5,1030a42.72,42.72,0,0,1,34.76.27,39.54,39.54,0,0,1,13.86,10.64,45.84,45.84,0,0,1,8.17,14.88A52.34,52.34,0,0,1,649.87,1072.12Zm-.77,0a34.41,34.41,0,0,0-3.75-15.5,37.55,37.55,0,0,0-9.84-12.08,45.39,45.39,0,0,0-13.1-7.37,41,41,0,0,0-14.47-2.5,41.55,41.55,0,0,0-14.37,2.77,39,39,0,0,0-12.45,7.87,41.49,41.49,0,0,0-12.63,26.81,36.46,36.46,0,0,0,2.27,15.4,34.88,34.88,0,0,0,22.09,21,42.08,42.08,0,0,0,15.09,1.91,47.53,47.53,0,0,0,27.65-10.69,38.16,38.16,0,0,0,9.82-12.13A34,34,0,0,0,649.1,1072.12Z"
        transform="translate(-23.54 -2.05)"
      />
      <circle class="cls-4" cx="409.24" cy="1077.41" r="41.55" />
      <path
        class="cls-2"
        d="M474.71,1079.46a53,53,0,0,1-2.64,16.27,45.32,45.32,0,0,1-8.19,14.84A38.49,38.49,0,0,1,450,1121a39.15,39.15,0,0,1-17.2,3.22,41.76,41.76,0,0,1-16.72-4.41,49.36,49.36,0,0,1-13.54-10.09,48.26,48.26,0,0,1-13.4-30.25,41.94,41.94,0,0,1,11.71-32,44.31,44.31,0,0,1,14.51-10.14,42.51,42.51,0,0,1,17.44-3.56,43,43,0,0,1,17.32,3.83A39.61,39.61,0,0,1,464,1048.27a45.88,45.88,0,0,1,8.17,14.89A52.3,52.3,0,0,1,474.71,1079.46Zm-.77,0a34.41,34.41,0,0,0-3.75-15.5,37.55,37.55,0,0,0-9.84-12.08,45.28,45.28,0,0,0-13.1-7.37,40.75,40.75,0,0,0-14.47-2.5,41.32,41.32,0,0,0-14.37,2.77,39.13,39.13,0,0,0-12.45,7.86,41.54,41.54,0,0,0-12.63,26.82,36.3,36.3,0,0,0,2.27,15.4,34.84,34.84,0,0,0,22.09,21,41.87,41.87,0,0,0,15.09,1.92,47.5,47.5,0,0,0,27.64-10.69,38.06,38.06,0,0,0,9.83-12.13A34.08,34.08,0,0,0,473.94,1079.46Z"
        transform="translate(-23.54 -2.05)"
      />
      <circle class="cls-4" cx="227.53" cy="1069.34" r="41.55" />
      <path
        class="cls-2"
        d="M293,1071.38a53.14,53.14,0,0,1-2.64,16.28,45.28,45.28,0,0,1-8.19,14.83,38.37,38.37,0,0,1-13.9,10.42,39,39,0,0,1-17.21,3.22,41.6,41.6,0,0,1-16.71-4.41,49.33,49.33,0,0,1-13.54-10.08,48.29,48.29,0,0,1-13.4-30.26,41.94,41.94,0,0,1,11.71-32,44.61,44.61,0,0,1,14.51-10.14,42.72,42.72,0,0,1,34.76.27,39.63,39.63,0,0,1,13.86,10.64,45.84,45.84,0,0,1,8.17,14.88A52.34,52.34,0,0,1,293,1071.38Zm-.77,0a34.41,34.41,0,0,0-3.75-15.5,37.4,37.4,0,0,0-9.84-12.07,45.32,45.32,0,0,0-13.1-7.38,41,41,0,0,0-14.48-2.5,41.77,41.77,0,0,0-14.36,2.77,39,39,0,0,0-12.45,7.87,41.49,41.49,0,0,0-12.63,26.81,36.3,36.3,0,0,0,2.27,15.4,35.58,35.58,0,0,0,8.67,13.1,35.15,35.15,0,0,0,13.42,7.93,42,42,0,0,0,15.08,1.92,47.45,47.45,0,0,0,27.65-10.7,38.06,38.06,0,0,0,9.83-12.13A34.08,34.08,0,0,0,292.23,1071.38Z"
        transform="translate(-23.54 -2.05)"
      />
    </svg>

    <svg
      class="girl-svg panda-carector pc-1"
      id="Layer_3"
      data-name="Layer 3"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 133.81 298.52"
    >
      <defs></defs>
      <path
        class="cls-1"
        d="M74,238.69a224.16,224.16,0,0,1,2.78,22.45c.49,6.75.64,13.09.56,19l11.21,1.12q.35-9.6.83-19.44.59-11.65,1.34-23Z"
        transform="translate(-27.61 -0.38)"
      />
      <path
        class="cls-2"
        d="M89,279l.6-6a15.55,15.55,0,0,1-12.86-.39l0,6.84-1.55.71.64,5.21,11.32.21,2.41-2.23Z"
        transform="translate(-27.61 -0.38)"
      />
      <path
        class="cls-3"
        d="M89.52,279.62a15.53,15.53,0,0,1,1.49,5c.2,1.74.43,3.62-.45,5.07-1,1.71-2.74,1.35-6.65,2.61-4.86,1.58-5.34,3.14-11,4.8a15.57,15.57,0,0,1-5.13.52,8.62,8.62,0,0,1-4.57-1.22A5.5,5.5,0,0,1,61,294.13c-1.21-3,2.88-7.15,4.11-8.39a21.53,21.53,0,0,1,10.05-5.56,4.55,4.55,0,0,0,1.32,1.93C79.05,284.27,84.29,283.27,89.52,279.62Z"
        transform="translate(-27.61 -0.38)"
      />
      <path
        class="cls-1"
        d="M35.8,197.91a25.6,25.6,0,0,0-5.44,5.69,11.66,11.66,0,0,0-2,3.7,7.33,7.33,0,0,0,1.05,5.13c1.55,2.39,6.33,3.88,7.67,4.09a11.46,11.46,0,0,0,3.12.07.9.9,0,0,0,.72-1.29,8.62,8.62,0,0,1-.45-6.12c.74-2.28,1.08-2.7,1.26-2.67.44.08-.2,2.84,1.28,4.16l0,0a1.45,1.45,0,0,0,2.35-.79,12.2,12.2,0,0,0,.33-2.36A12.93,12.93,0,0,0,43.48,200Z"
        transform="translate(-27.61 -0.38)"
      />
      <path
        class="cls-1"
        d="M115.6,239.26a222,222,0,0,0-3.06,22.41c-.57,6.74-.79,13.08-.78,18.95l-11.23,1q-.23-9.62-.59-19.45-.45-11.67-1.07-23Z"
        transform="translate(-27.61 -0.38)"
      />
      <path
        class="cls-2"
        d="M100.15,279.37l-.53-6a18,18,0,0,0,12.87-.23l-.12,6.84,1.54.73-.7,5.2-11.32.07-2.38-2.26Z"
        transform="translate(-27.61 -0.38)"
      />
      <path
        class="cls-3"
        d="M99.58,280A15.64,15.64,0,0,0,98,285c-.23,1.74-.47,3.62.39,5.09,1,1.72,2.73,1.37,6.62,2.69,4.84,1.64,5.29,3.2,10.95,4.92a15.29,15.29,0,0,0,5.12.59,8.68,8.68,0,0,0,4.58-1.17,5.39,5.39,0,0,0,2.21-2.26c1.25-3-2.79-7.19-4-8.44a21.54,21.54,0,0,0-10-5.68,4.5,4.5,0,0,1-1.34,1.92C110,284.77,104.77,283.71,99.58,280Z"
        transform="translate(-27.61 -0.38)"
      />
      <path class="cls-2" d="M125.51,264.64" transform="translate(-27.61 -0.38)" />
      <path
        class="cls-1"
        d="M151.85,193.38a25.47,25.47,0,0,1,6.13,4.93,11.76,11.76,0,0,1,2.49,3.4,7.39,7.39,0,0,1-.38,5.23c-1.23,2.58-5.77,4.67-7.08,5.06a11.72,11.72,0,0,1-3.07.47.91.91,0,0,1-.89-1.19,8.65,8.65,0,0,0,.39-3.12,9,9,0,0,0-.73-3c-1-2.16-1.43-2.54-1.61-2.48-.42.14.57,2.79-.72,4.3l0,0a1.45,1.45,0,0,1-2.43-.48,12.13,12.13,0,0,1-.63-2.3,12.93,12.93,0,0,1,1.2-7.8Z"
        transform="translate(-27.61 -0.38)"
      />
      <path
        class="cls-4"
        d="M62.84,29c-3.71-1.27-11-3-17.57.27-13,6.49-13.28,27.4-13.28,29h0a36.27,36.27,0,0,0,1.84,9.95,153.15,153.15,0,0,1,6.54,32.16,153.06,153.06,0,0,1,.47,21.93,100.49,100.49,0,0,1-2.34,15.91,101.54,101.54,0,0,1-4.67,14.92,161.85,161.85,0,0,0,67.75,14.05A161,161,0,0,0,155.77,157a65.88,65.88,0,0,1-8.88-34.71,92.55,92.55,0,0,1,8.88-36.42c2.28-4.8,3.83-13.85,2.81-24.76a.84.84,0,0,1,0-.19A68.21,68.21,0,0,0,154,43c-2.76-6.37-11.24-17.86-25.68-25.62-4.21-2.27-32.63-17.54-53.12-3.53A36.72,36.72,0,0,0,62.84,29Z"
        transform="translate(-27.61 -0.38)"
      />
      <path
        class="cls-5"
        d="M71,123.8a19.48,19.48,0,0,0-7.83,4.92,18.18,18.18,0,0,0-3,4.25c-12.28,23.38-21.65,50.78-24.31,64.18a6.9,6.9,0,0,0,3,3.69,7,7,0,0,0,5.17.74c2.75-3,22.35-44.76,25.71-54.23a102,102,0,0,1,2.74,13.82,121.33,121.33,0,0,1,.77,15.88c-.22,10.77-10.34,35.88-20,70.27,15.25,5.65,33.26,8,41.69,7.94,16-.15,42-5.24,42-5.24-9.55-36.77-20.55-63.9-21.58-74.19A94.65,94.65,0,0,1,115,162a80.09,80.09,0,0,1,2.25-14.3c2.79,6.47,5.77,13.16,9.19,19.94,5.53,11,11.19,21.36,16.87,31.12A12.24,12.24,0,0,0,152.5,193c-10-23.27-17-40.37-19.86-50.36-.92-3.17-3.14-11.54-10.49-17.45a26.25,26.25,0,0,0-4.36-2.84Z"
        transform="translate(-27.61 -0.38)"
      />
      <ellipse
        class="cls-6"
        cx="81.76"
        cy="127.5"
        rx="9.28"
        ry="12.51"
        transform="translate(-97.09 135.3) rotate(-60.42)"
      />
      <ellipse
        class="cls-6"
        cx="104.99"
        cy="127.23"
        rx="12.54"
        ry="9.25"
        transform="translate(-79.49 75.84) rotate(-32.46)"
      />
      <ellipse class="cls-7" cx="65.98" cy="127.13" rx="5.15" ry="4.2" />
      <ellipse class="cls-8" cx="64.67" cy="78.42" rx="44.66" ry="48.37" />
      <path
        class="cls-4"
        d="M93.17,100.51a5.08,5.08,0,0,0-5.89-.3,3.65,3.65,0,0,0-1.58,2.14,5.53,5.53,0,0,0,.29,3.3,4,4,0,0,1-2.07-3.44,4.52,4.52,0,0,1,2.13-3.89,5.06,5.06,0,0,1,4.29-.65A4.16,4.16,0,0,1,93.17,100.51Z"
        transform="translate(-27.61 -0.38)"
      />
      <path
        class="cls-9"
        d="M99.75,108A7.55,7.55,0,0,1,95.43,116a7.24,7.24,0,0,1-4.89.33,6.54,6.54,0,0,1-3.75-2.74,11.85,11.85,0,0,0,4,1.07,8.29,8.29,0,0,0,3.72-.64,8.62,8.62,0,0,0,3-2.31A16.74,16.74,0,0,0,99.75,108Z"
        transform="translate(-27.61 -0.38)"
      />
      <path class="cls-10" d="M151,91.75" transform="translate(-27.61 -0.38)" />
      <path
        class="cls-11"
        d="M117.19,180.79c-7.1.5-14.81.82-23.07.82s-16-.31-23.17-.82l.69-6.41c7,.28,14.38.44,22,.44q11.79,0,22.64-.44Z"
        transform="translate(-27.61 -0.38)"
      />
      <path class="cls-2" d="M65.13,265.6" transform="translate(-27.61 -0.38)" />
      <ellipse class="cls-12" cx="66.64" cy="147.49" rx="4.76" ry="4.81" />
      <ellipse class="cls-12" cx="66.64" cy="161.45" rx="4.76" ry="4.81" />
      <ellipse class="cls-13" cx="46.79" cy="84.31" rx="9.91" ry="14.31" />
      <ellipse class="cls-14" cx="46.32" cy="84.38" rx="6.37" ry="10.44" />
      <ellipse class="cls-13" cx="47.95" cy="79.85" rx="3.85" ry="4.38" />
      <path
        class="cls-15"
        d="M83.31,78.4a12.58,12.58,0,0,0-3.71-4.83,10.74,10.74,0,0,0-5.3-2.11h.11a8.9,8.9,0,0,0-5,1.54,10.67,10.67,0,0,0-3.55,4.34,7.6,7.6,0,0,1,.66-3,8.11,8.11,0,0,1,1.84-2.61,8.82,8.82,0,0,1,6-2.42h.12a10,10,0,0,1,6.24,3,9.52,9.52,0,0,1,1.9,2.86A8.39,8.39,0,0,1,83.31,78.4Z"
        transform="translate(-27.61 -0.38)"
      />
      <ellipse class="cls-13" cx="82.21" cy="84.8" rx="9.91" ry="14.31" />
      <ellipse class="cls-14" cx="81.74" cy="84.86" rx="6.37" ry="10.44" />
      <ellipse class="cls-13" cx="83.37" cy="80.33" rx="3.85" ry="4.38" />
      <path
        class="cls-15"
        d="M118.73,78.89A12.45,12.45,0,0,0,115,74.05a10.79,10.79,0,0,0-5.3-2.11h.11a8.92,8.92,0,0,0-5,1.53,10.67,10.67,0,0,0-3.55,4.34,7.6,7.6,0,0,1,.66-3,8.26,8.26,0,0,1,1.84-2.61,8.81,8.81,0,0,1,6-2.41h.12a10,10,0,0,1,6.24,3,9.46,9.46,0,0,1,1.9,2.86A8.26,8.26,0,0,1,118.73,78.89Z"
        transform="translate(-27.61 -0.38)"
      />
      <path
        class="cls-4"
        d="M109.35,63.13a6.39,6.39,0,0,1,3.9-3,7.33,7.33,0,0,1,5.2.52,7.8,7.8,0,0,1,4.39,8.38,18.24,18.24,0,0,0-2.61-3.49,11,11,0,0,0-3.07-2.26,8.29,8.29,0,0,0-3.57-.88A13.53,13.53,0,0,0,109.35,63.13Z"
        transform="translate(-27.61 -0.38)"
      />
      <path
        class="cls-4"
        d="M60.29,65.89a6.87,6.87,0,0,1-.39-5,7.52,7.52,0,0,1,3.2-4.28,7.91,7.91,0,0,1,5.15-1.24,6.87,6.87,0,0,1,4.49,2.18,16.69,16.69,0,0,0-4.43.19,10,10,0,0,0-3.58,1.4,8.83,8.83,0,0,0-2.66,2.68A16.47,16.47,0,0,0,60.29,65.89Z"
        transform="translate(-27.61 -0.38)"
      />
      <path
        class="cls-15"
        d="M68,73.33a4.33,4.33,0,0,1-2.13.42,3.45,3.45,0,0,1-1.59-.48,3.56,3.56,0,0,1-1.19-1.16A4.36,4.36,0,0,1,62.41,70v-.1a.07.07,0,0,1,.07-.09h.05c1,.47,1.89,1,2.84,1.55s1.85,1.11,2.73,1.74a.09.09,0,0,1,0,.11s0,0,0,0Z"
        transform="translate(-27.61 -0.38)"
      />
      <path
        class="cls-15"
        d="M122.1,71.87a4.47,4.47,0,0,1-.4,2.14,3.55,3.55,0,0,1-1,1.29,3.46,3.46,0,0,1-1.52.67,4.38,4.38,0,0,1-2.16-.16l-.1,0a.08.08,0,0,1-.06-.1l0,0c.79-.73,1.66-1.37,2.49-2s1.72-1.31,2.64-1.89a.08.08,0,0,1,.11,0s0,0,0,0Z"
        transform="translate(-27.61 -0.38)"
      />
      <path
        class="cls-15"
        d="M70.24,71.59a4.54,4.54,0,0,1-2.17-.12,3.47,3.47,0,0,1-1.42-.87,3.57,3.57,0,0,1-.86-1.42A4.53,4.53,0,0,1,65.67,67l0-.1a.08.08,0,0,1,.09-.07l0,0c.83.7,1.58,1.48,2.37,2.21s1.51,1.54,2.21,2.36a.09.09,0,0,1,0,.12l0,0Z"
        transform="translate(-27.61 -0.38)"
      />
      <path
        class="cls-15"
        d="M119.8,68.22a4.32,4.32,0,0,1,.32,2.15,3.52,3.52,0,0,1-.56,1.57,3.42,3.42,0,0,1-1.22,1.13,4.41,4.41,0,0,1-2.09.56h-.11a.08.08,0,0,1-.08-.08.06.06,0,0,1,0,0c.51-1,1.12-1.84,1.68-2.76s1.2-1.8,1.87-2.65a.09.09,0,0,1,.12,0s0,0,0,0Z"
        transform="translate(-27.61 -0.38)"
      />
      <path
        class="cls-4"
        d="M62.62,39.83A59.13,59.13,0,0,0,75.29,55,59.57,59.57,0,0,0,99,67.34C95.8,65.87,86.57,61.11,82.65,50.9A26.54,26.54,0,0,1,81,44.05a100.42,100.42,0,0,0,12.26,9.37A99.45,99.45,0,0,0,115,64a71.53,71.53,0,0,1-9.25-12,70.72,70.72,0,0,1-6.26-13A94,94,0,0,0,118.3,59,94.16,94.16,0,0,0,145,73.77L114.15,22.43,63.47,31.76Z"
        transform="translate(-27.61 -0.38)"
      />
      <ellipse class="cls-16" cx="34.62" cy="100.9" rx="5.24" ry="2.82" />
      <ellipse class="cls-16" cx="94.48" cy="100.9" rx="5.24" ry="2.82" />
      <path class="cls-17" d="M86.79,113" transform="translate(-27.61 -0.38)" />
      <path
        class="cls-18"
        d="M80.66,22.42a46.38,46.38,0,0,1,35,2.64c16.31,8.21,22.88,23.3,24.38,27a75.79,75.79,0,0,0-26.31-22.21A69.33,69.33,0,0,0,80.66,22.42Z"
        transform="translate(-27.61 -0.38)"
      />
      <path
        class="cls-18"
        d="M117.45,27.71a2.14,2.14,0,0,1-1.25-3.23A55.71,55.71,0,0,1,125,13.39a52.47,52.47,0,0,1,5.47-4.64,1.81,1.81,0,0,1,1.9-.16,12.6,12.6,0,0,1,6.32,7.3,14,14,0,0,1-.33,9.44,2,2,0,0,1-1.2,1.18,38.08,38.08,0,0,1-6.47,1.58A37.69,37.69,0,0,1,117.45,27.71Z"
        transform="translate(-27.61 -0.38)"
      />
      <path
        class="cls-18"
        d="M117.16,23.62a1.93,1.93,0,0,1-2.89,1.58,53.08,53.08,0,0,1-10.8-8.79,53.69,53.69,0,0,1-4.63-5.61,2.21,2.21,0,0,1-.28-2,12.67,12.67,0,0,1,6.28-7.34,11.11,11.11,0,0,1,8.7-.29,2,2,0,0,1,1.17,1.22,46.48,46.48,0,0,1,1.89,6.89A48,48,0,0,1,117.16,23.62Z"
        transform="translate(-27.61 -0.38)"
      />
      <path
        class="cls-19"
        d="M31.72,214.07c-.14-.57-.32-1.13-.42-1.71a8.62,8.62,0,0,1-.11-1.83,8.14,8.14,0,0,1,.26-1.76,7.82,7.82,0,0,0,.48-1.68.22.22,0,0,0-.37-.15,3.07,3.07,0,0,0-.81,1.64,9.23,9.23,0,0,0-.32,1.95,6.8,6.8,0,0,0,.75,3.77.3.3,0,0,0,.54-.23Z"
        transform="translate(-27.61 -0.38)"
      />
      <path
        class="cls-19"
        d="M34.23,207.91a7.11,7.11,0,0,0-1,4,6.24,6.24,0,0,0,1.24,3.9.22.22,0,0,0,.37-.21c-.17-.64-.46-1.24-.62-1.88a8.54,8.54,0,0,1-.28-1.88,10.52,10.52,0,0,1,.63-3.81c.08-.23-.26-.36-.38-.16Z"
        transform="translate(-27.61 -0.38)"
      />
      <path
        class="cls-19"
        d="M36.72,208.86a9,9,0,0,0,.1,4,8.77,8.77,0,0,0,.69,1.85,4.15,4.15,0,0,0,1.17,1.65.28.28,0,0,0,.41-.32,12.47,12.47,0,0,0-.9-1.59,10.36,10.36,0,0,1-.68-1.78,9.88,9.88,0,0,1-.29-3.75c0-.28-.44-.35-.5-.07Z"
        transform="translate(-27.61 -0.38)"
      />
      <path
        class="cls-19"
        d="M151.53,203.56a12.27,12.27,0,0,1,1.35,4.22,8.36,8.36,0,0,1,0,2.12,4.07,4.07,0,0,1-.24.91,1.56,1.56,0,0,0-.18.85.17.17,0,0,0,.2.11c.63-.19.78-1.13.87-1.69a8,8,0,0,0,0-2.24,11.12,11.12,0,0,0-1.64-4.49.2.2,0,0,0-.35.21Z"
        transform="translate(-27.61 -0.38)"
      />
      <path
        class="cls-19"
        d="M154.26,203.33c.22.6.52,1.17.73,1.78a8,8,0,0,1,.45,2,8.57,8.57,0,0,1,0,2q-.08.48-.18,1c-.07.3-.24.65-.13,1a.3.3,0,0,0,.44.19,1.4,1.4,0,0,0,.48-.86,7.67,7.67,0,0,0,.22-1.06,8.53,8.53,0,0,0,0-2.2,6.58,6.58,0,0,0-1.59-3.94c-.16-.16-.49,0-.4.24Z"
        transform="translate(-27.61 -0.38)"
      />
      <path
        class="cls-19"
        d="M156.86,202.53a9.8,9.8,0,0,1,1.49,3.25,6.93,6.93,0,0,1,.13,1.76,8.27,8.27,0,0,1-.11.87,1.21,1.21,0,0,0,0,.88.3.3,0,0,0,.39.1c.54-.26.53-1.28.56-1.79a7.92,7.92,0,0,0-.17-2,6.15,6.15,0,0,0-1.86-3.44c-.25-.21-.68.06-.48.37Z"
        transform="translate(-27.61 -0.38)"
      />
    </svg>

    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 753.13 949.57"
      class="main-panda-loading"
    >
      <g id="Layer_2" data-name="Layer 2">
        <g id="Layer_1-2" data-name="Layer 1">
          <path
            id="panda-hand"
            d="M511.92,494.1c2.34,8.39,17.6,60.14,61.13,76.31,53.64,19.92,106.19-30.56,123.63-47.32,31-29.77,41.43-62.06,47.59-81.12,7.27-22.5,14.27-45.3,2.75-66.18-1.58-2.86-10.25-18.62-28.11-23.83-15.43-4.49-28.15,1.34-35.53,4.72-18.27,8.38-27.31,23.81-32.92,33.25-42.79,72-45.43,88.82-63.4,97.49-11.54,5.58-31.26,8.68-65.72-7.62Z"
            style="fill: #312f2d"
          />
          <path
            d="M381.11,846.53c-1,25.46-1.92,45.45-3.11,63.1-.45,6.73-1.14,16.21,4.94,23.64,6.32,7.72,16.58,9.14,21.66,9.46q108.34,15.79,113.93-4.88,2.07-7.65-10-20.33A110.7,110.7,0,0,0,495.09,907a104.53,104.53,0,0,0-17.33-9.28,470.75,470.75,0,0,0,34.29-66c30-70.87,38.19-137.48,39.94-183.68C543.9,684.87,400.38,837.87,381.11,846.53Z"
            style="fill: #312f2d"
          />
          <path
            d="M322.54,846.53c.65,27,1.64,47,2.88,63.44.49,6.42,1.29,15.88-4.72,23.3-6.24,7.73-16.54,9.14-21.65,9.46q-108.36,15.79-113.94-4.88-2.07-7.65,10-20.33A109.16,109.16,0,0,1,208.56,907a104.48,104.48,0,0,1,17.32-9.28,471.82,471.82,0,0,1-34.29-66c-30-70.87-38.18-137.48-39.94-183.68C159.75,684.87,303.27,837.87,322.54,846.53Z"
            style="fill: #312f2d"
          />
          <ellipse
            cx="352.91"
            cy="628.63"
            rx="200.17"
            ry="224.11"
            style="
              fill: #fff;
              stroke: #313438;
              stroke-miterlimit: 10;
              stroke-width: 6.92464948779745px;
            "
          />
          <path
            d="M503,498.3c-20,33.8-61.21,79.14-105.64,122.49-41.28,40.28-90.2,54.88-122.7,73.76-.37,1.67,6.16,22.91,11,30.26,4.59,7,13.18,10.71,22.08,9.63a288.75,288.75,0,0,0,71.58-35.52,292.21,292.21,0,0,0,52.73-46.5c52.11-57.13,77.22-129.13,86.87-160.84Z"
            style="fill: #6e2e2b"
          />
          <path
            d="M304.64,730.32a289.85,289.85,0,0,1-10.55,84.12,289.33,289.33,0,0,1-28.9,68.4c-5.64,9.67-13.7,14.39-21.86,17.9a48.19,48.19,0,0,1-24.62,3.5,337.83,337.83,0,0,1-99-22.09C77,865.49,52.82,851.46,49.17,830,45.79,810,63.5,796.41,83.37,768.44c17.18-24.19,38-61.91,49.31-118.54Z"
            style="
              fill: #d5664d;
              stroke: #6e2e2b;
              stroke-miterlimit: 10;
              stroke-width: 11.9335925511827px;
            "
          />
          <path
            d="M306,733.81c-1-5.63-2.73-9.64-8-17.62-2.24-3.35-4.19-6.43-5.87-9.4-5.21-9.2-14.85-27.86-32.13-40.45,0,0-43.88-39.14-115.74-41.36a52.93,52.93,0,0,0-13.13,1.36,56.27,56.27,0,0,0-15.91,7.42c-9.51,6.5-52.55,45.33-38.74,82.64C98,774.53,163.28,817.75,219.09,806.6c23.36-4.67,43-18.24,44.18-19.1C286.69,771,301.11,744,306,733.81Z"
            style="fill: #6e2e2b"
          />
          <path
            d="M194.56,491.18c-8,3.35-57.55,24.81-68.28,70-13.23,55.67,43.28,101.67,62,116.94,33.33,27.13,66.64,33.55,86.31,37.34,23.22,4.48,46.71,8.65,66-5.34,2.65-1.92,17.23-12.44,20.22-30.8,2.58-15.86-4.76-27.78-9-34.69-10.54-17.12-27-24.2-37-28.62-76.67-33.69-93.7-34.26-104.5-51-6.94-10.78-12.42-30-.45-66.16Z"
            style="fill: #312f2d"
          />
          <path
            d="M573.43,215.27a8.67,8.67,0,0,0,8.33,2.2c15.77-4,50.64-15.92,77.18-49.94a142.07,142.07,0,0,0,28.58-69c0-.23.06-.46.07-.7,1-15.41-.47-44-31.54-72.5S587.32-.2,581.37.37A133.71,133.71,0,0,0,513.7,28.54c-32.26,25.86-43.15,59.73-46.78,75.32A9.68,9.68,0,0,0,469.4,113Z"
            style="fill: #312f2d"
          />
          <path
            d="M219.8,110.81a9,9,0,0,0-1.93-8.77c-29-32.61-83.39-47.71-83.39-47.71-14-3.28-24.59-5.66-39.16-4.48A110.88,110.88,0,0,0,55.89,61c-5.07,2.42-13.69,6.45-22.06,13.52-11.6,9.8-23.45,25.28-30.32,50.29C-8.14,167.29,12.65,200.71,16,206a139.56,139.56,0,0,0,58.58,49.28c39.49,17.56,76.21,11.5,92.46,7.43A10.14,10.14,0,0,0,174.4,256Q197.1,183.4,219.8,110.81Z"
            style="fill: #312f2d"
          />
          <path
            d="M286,37.31c-16.44,4.36-121.46,34-187.16,137.32-9.59,15.09-96.44,155.92-31.39,260,29.44,47.1,77,66,110.72,79.32,83.92,33.25,159.08,19.16,223.2,7.14,60.05-11.25,140-27.28,210.09-91.18,26.75-24.4,53.66-49,65.76-89.5,30.73-103-65.42-204.54-79.39-218.86C520.78,42.57,398.58,7.45,286,37.31Z"
            style="
              fill: #fff;
              stroke: #313438;
              stroke-miterlimit: 10;
              stroke-width: 6.92464948779745px;
            "
          />
          <path
            d="M530.59,134.05c-14-5.69-40.5-11.58-66,2.2-28.65,15.51-36.85,47.2-39.51,57.51-14.41,55.64,21.95,102.06,25.61,106.58a131.57,131.57,0,0,0,48.77,36.06,26.07,26.07,0,0,0,4.38,1.43c28.64,6.73,66.39,2.7,95.64-20.05,11.9-9.26,25.51-19.85,31.33-38.93,10.14-33.24-11.52-65.58-24.48-84.93C598,181.39,573,151.28,530.59,134.05Z"
            style="fill: #383634"
          />
          <path
            d="M532,211.42a42.49,42.49,0,0,1,9.6,19.94,41.67,41.67,0,0,1,.5,11.8,53.82,53.82,0,0,1-5,13.1c-2.07,3.9-6.87,12.6-16.46,18.6-16.88,10.57-35.57,4.63-37.29,4.05-3.56-1.19-16.67-5.82-24.18-19.6-8.17-15-3.73-29.77-2.54-33.75,1.29-4.3,4.78-15.92,16.11-23.47,13.4-8.94,28.19-5.8,33.85-4.6C511.54,198.53,523,201.13,532,211.42Z"
          />
          <path
            d="M494.74,214.17a14.81,14.81,0,0,1,3.36,7,14.32,14.32,0,0,1,.17,4.12,18.1,18.1,0,0,1-1.73,4.59,16.56,16.56,0,0,1-5.76,6.5c-5.9,3.7-12.44,1.62-13,1.42a15,15,0,0,1-8.46-6.86,15.28,15.28,0,0,1-.88-11.8,14.4,14.4,0,0,1,5.63-8.21c4.69-3.13,9.86-2,11.84-1.61A15.64,15.64,0,0,1,494.74,214.17Z"
            style="
              fill: #fff;
              stroke: #1d1d1b;
              stroke-miterlimit: 10;
              stroke-width: 0.735171823576394px;
            "
          />
          <path
            d="M151.15,185.85c4.18-3.42,29.19-23.24,63.94-17.66,26,4.18,48.4,21.57,60,43.33,6.53,12.23,8.05,22.77,9.85,35.36s5.6,41.5-7.39,73.71a131.86,131.86,0,0,1-36,49,28.34,28.34,0,0,1-3.78,2.67c-25.45,15-62.87,22.47-97.75,9.52-14.18-5.27-30.41-11.3-41.71-27.76-19.68-28.68-8.59-66-2-88.38C100.71,251.2,115.6,215,151.15,185.85Z"
            style="fill: #383634"
          />
          <path
            d="M262.28,242.89a42.5,42.5,0,0,1,9.61,19.94,41.84,41.84,0,0,1,.49,11.79,53.09,53.09,0,0,1-4.94,13.11c-2.07,3.89-6.88,12.6-16.47,18.6-16.87,10.57-35.56,4.63-37.29,4.05-3.56-1.2-16.67-5.83-24.18-19.6-8.17-15-3.73-29.77-2.54-33.75,1.29-4.31,4.78-15.92,16.11-23.48,13.4-8.93,28.19-5.8,33.85-4.6C241.84,230,253.31,232.6,262.28,242.89Z"
          />
          <path
            d="M246,248.32a14.24,14.24,0,0,1,3.5,7,13.71,13.71,0,0,1,.15,4.13,18.73,18.73,0,0,1-1.87,4.62,17.36,17.36,0,0,1-6.17,6.57c-6.28,3.76-13.19,1.74-13.83,1.54a15.41,15.41,0,0,1-8.9-6.8c-3-5.23-1.29-10.43-.84-11.83a14.8,14.8,0,0,1,6-8.29c5-3.18,10.46-2.12,12.56-1.72A16.54,16.54,0,0,1,246,248.32Z"
            style="
              fill: #fff;
              stroke: #1d1d1b;
              stroke-miterlimit: 10;
              stroke-width: 0.757960181056497px;
            "
          />
          <path
            d="M329.5,361.91a18.06,18.06,0,0,1,1.23-8.23,17.27,17.27,0,0,1,1.87-3c3.7-4.62,11.78-9,35.67-12.64,0,0,37.46-7.21,47.12,1a13,13,0,0,1,4.42,7.28c1,4.2-.4,9.66-1.28,11.9-2.16,5.54-14.8,26.9-39.79,29.9-18.88,2.27-32.44-7.44-37.91-11.36C340.83,376.76,330.71,369.52,329.5,361.91Z"
            style="fill: #252321"
          />
          <path
            d="M382.52,449a44.8,44.8,0,0,1-7.2,3.15c-1.23.45-2.47.77-3.72,1.15s-2.51.61-3.77.9a73,73,0,0,1-15.4,1.43,84.17,84.17,0,0,1-56.29-23.13,73.12,73.12,0,0,1-9.95-11.84,53.09,53.09,0,0,1-6.82-14l.93-.84a129.38,129.38,0,0,0,10.36,9.79,133.31,133.31,0,0,0,36.21,22.16,126.36,126.36,0,0,0,13.39,4.69c4.55,1.32,9.18,2.35,13.84,3.22a142,142,0,0,0,28.35,2.08Z"
            style="fill: #252321"
          />
        </g>
      </g>
    </svg>

    <svg
      class="panda-carector grand pc-2"
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 523.91 1140.62"
    >
      <defs>
        <pattern
          id="New_Pattern_Swatch_2"
          data-name="New Pattern Swatch 2"
          width="37.21"
          height="30.9"
          patternUnits="userSpaceOnUse"
          viewBox="0 0 37.21 30.9"
        >
          <rect class="cls-1" width="37.21" height="30.9" />
          <path class="cls-2" d="M0,22.11" />
          <rect class="cls-3" width="37.21" height="30.9" />
          <path
            class="cls-4"
            d="M0,0C2.13,2.07,4,4.24,5.93,6.4S9.61,10.8,11.36,13c3.49,4.48,6.77,9.06,9.88,13.72H16c1.55-2.33,3.14-4.65,4.78-6.94s3.32-4.56,5.08-6.79,3.55-4.46,5.43-6.64S35.07,2.06,37.21,0c-1,2.6-2.16,5.09-3.35,7.59S31.34,12.52,30,14.94s-2.77,4.81-4.22,7.19-3,4.71-4.53,7.05a3.36,3.36,0,0,1-4.09,1,3,3,0,0,1-1.18-1q-4.63-7-8.73-14.25C5.9,12.5,4.59,10.06,3.37,7.58S1,2.6,0,0Z"
          />
        </pattern>
      </defs>
      <title>grandfather</title>
      <path
        class="cls-5"
        d="M402.65,1094.92a93.06,93.06,0,0,1,9.33,45.77,147.22,147.22,0,0,1-70.21,26.21,84,84,0,0,1-35.66-2.68,81.73,81.73,0,0,1-14.11-5.76c-.9-.48-10.71-5.9-11.86-16.92a21.56,21.56,0,0,1,3.42-13.74,44.19,44.19,0,0,1,3.76-4.67c8.5-9.23,18.34-12,37.14-17.91,5.07-1.6,14-4.43,25.71-8.27Z"
        transform="translate(-125.52 -29.4)"
      />
      <path
        class="cls-6"
        d="M412.11,1131.91c-12.55,10-38.25,27.39-73,28.72a112.09,112.09,0,0,1-21.72-1.28,88.22,88.22,0,0,1-37.22-17.81,29.37,29.37,0,0,0,24.3,22.15,108.7,108.7,0,0,0,26.35,4,110.32,110.32,0,0,0,44.94-8.35,145,145,0,0,0,16.62-7A147.06,147.06,0,0,0,412,1140.69Z"
        transform="translate(-125.52 -29.4)"
      />
      <path
        class="cls-7"
        d="M368.73,1127.44a60.32,60.32,0,0,0-27,18c-2.69,3.18-10.52,22.31-10.52,22.31a165.1,165.1,0,0,0,25.26-3.38,143.82,143.82,0,0,0,29.93-9.49,139.71,139.71,0,0,0,25.09-14.48,53.36,53.36,0,0,0-2.35-25.51Z"
        transform="translate(-125.52 -29.4)"
      />
      <path
        class="cls-5"
        d="M519.64,1095.49a93.12,93.12,0,0,1,9.33,45.77,147.06,147.06,0,0,1-70.21,26.22,84,84,0,0,1-35.66-2.69A81.76,81.76,0,0,1,409,1159c-.9-.49-10.71-5.91-11.86-16.93a21.58,21.58,0,0,1,3.42-13.74,45.25,45.25,0,0,1,3.76-4.67c8.5-9.22,18.34-12,37.14-17.91,5.07-1.59,14-4.43,25.71-8.27Z"
        transform="translate(-125.52 -29.4)"
      />
      <path
        class="cls-6"
        d="M529.1,1132.48c-12.55,10-38.26,27.39-73,28.73a112.89,112.89,0,0,1-21.72-1.28,88.37,88.37,0,0,1-37.22-17.82,29.37,29.37,0,0,0,24.3,22.15,108.7,108.7,0,0,0,26.35,4,110.15,110.15,0,0,0,44.94-8.35A146.61,146.61,0,0,0,529,1141.26Z"
        transform="translate(-125.52 -29.4)"
      />
      <path
        class="cls-7"
        d="M485.72,1128a60.36,60.36,0,0,0-27,18c-2.7,3.17-10.52,22.3-10.52,22.3a163.82,163.82,0,0,0,25.26-3.37,144.63,144.63,0,0,0,29.93-9.5,138.5,138.5,0,0,0,25.09-14.48,53.4,53.4,0,0,0-2.35-25.51Z"
        transform="translate(-125.52 -29.4)"
      />
      <path
        class="cls-5"
        d="M178.85,741.94c4.52,2.76,16.41,10.92,24.18,28a77,77,0,0,1,6.07,40.55,18.79,18.79,0,0,1-14.31,2.92,20.07,20.07,0,0,1-10.54-6.36,38.85,38.85,0,0,0,1.37-14.31,37.06,37.06,0,0,0-6.77-18.29c-5.7-5.63-13.51-7-19.8-3.45-7.14,4-9.1,12.47-9.37,13.74a32.92,32.92,0,0,0-1.6,7.46,37.55,37.55,0,0,0,.11,7.18c.15,1.84,5.18,111.51,5.18,111.51.68,48.32,2,187.8,1.71,219.1-2.38.35-16.23,1.31-16.23,1.31,0-54.76-1.08-192-2.34-222.29,0,0-3.37-32.77-8.8-124.85A62.7,62.7,0,0,1,131.35,760a45.76,45.76,0,0,1,9.37-13.95,39.54,39.54,0,0,1,8.25-6.36,37.1,37.1,0,0,1,14.2-2.12A37.84,37.84,0,0,1,178.85,741.94Z"
        transform="translate(-125.52 -29.4)"
      />
      <path
        class="cls-8"
        d="M171.58,717.33a106.43,106.43,0,0,0-16.42,7.86,107.63,107.63,0,0,0-18.48,13.73,39.07,39.07,0,0,0-7.92,15.84,30.51,30.51,0,0,0-.51,14.68c3,12.46,14.63,18.66,19.1,20.88a39.32,39.32,0,0,0,19.72,3.92c1.76,0,4-.38,5.45-2,3.44-3.84-2-10.37,1.19-17.5,1.72-3.91,5.67-7.24,8-6.51,3.36,1.06,1.5,10.06,5.89,12.25,2.31,1.15,5.35-.1,7.85-1.6A60.14,60.14,0,0,0,203,741.79a83,83,0,0,1-31.39-24.46Z"
        transform="translate(-125.52 -29.4)"
      />
      <path
        class="cls-9"
        d="M336.61,391.3A52.94,52.94,0,0,0,321,396.25c-16.7,8.38-28.25,25.81-42.44,80.92a722.14,722.14,0,0,0-16.66,86.32Q247.49,589.44,231.84,616q-31.77,53.79-64,102.3c12.53,3.3,33,26.35,45.52,29.66a444.79,444.79,0,0,0,57-59.12,444.65,444.65,0,0,0,46.35-71C324.51,545.68,328.77,463.46,336.61,391.3Z"
        transform="translate(-125.52 -29.4)"
      />
      <path
        class="cls-10"
        d="M526.53,1093.37a54.49,54.49,0,0,1-26.45,11.15c-21.24,2.72-36.89-8.48-40.43-11.15Q447,953.24,434.25,813.11l-24.31,280.26a83.31,83.31,0,0,1-66.88,0L313.48,713.82H555Z"
        transform="translate(-125.52 -29.4)"
      />
      <path
        class="cls-11"
        d="M572.91,777.38l-287.75-.33c15-103.78,17.81-164.24,17.18-201-.53-30.84,2.35-61.64,3.1-92.47a362.51,362.51,0,0,1,6.77-55.3c5.56-28.2,10.46-36,15.61-41.33,13.71-14.23,33.53-15.49,41.9-15.51H518.56a126.55,126.55,0,0,1,38.78,11.33c6.37,3,16.06,7.64,23.89,15,19.78,18.52,21.82,59.55,21.89,65.44C604,537.15,589.06,618,582.84,660A950.7,950.7,0,0,0,572.91,777.38Z"
        transform="translate(-125.52 -29.4)"
      />
      <rect class="cls-12" x="282.34" y="447.25" width="33.29" height="300.39" />
      <path
        class="cls-13"
        d="M322.58,361.29H522.76a687.1,687.1,0,0,1-57.9,94.91c-12.34,17-24.79,32.47-37,46.58q-22.57-26.7-45.53-56.74C360.16,417,340.33,388.57,322.58,361.29Z"
        transform="translate(-125.52 -29.4)"
      />
      <rect
        class="cls-12"
        x="454.41"
        y="394.65"
        width="20.08"
        height="126.12"
        transform="translate(221.86 -213.19) rotate(35.08)"
      />
      <rect
        class="cls-12"
        x="373.01"
        y="388.85"
        width="20.08"
        height="130.04"
        transform="translate(-315.03 266.65) rotate(-34.43)"
      />
      <path
        class="cls-14"
        d="M510.17,140c2.19-2.16,15.55-14.86,35.83-13.78a48,48,0,0,1,29.68,12.69A58,58,0,0,1,591,167.72a56.69,56.69,0,0,1,0,22.14,45.9,45.9,0,0,1,25.78,10,46.46,46.46,0,0,1,14.36,20.6,52.11,52.11,0,0,1,2,28.88,56.76,56.76,0,0,1-14.68,27.82c-19.27,20.5-47.18,19.47-51.84,19.23l-90.11-143.9Z"
        transform="translate(-125.52 -29.4)"
      />
      <path
        class="cls-14"
        d="M260.47,286.72c-3-.74-20.81-5.44-30.55-23.25a48,48,0,0,1-4.79-31.92,58.05,58.05,0,0,1,16.49-28.2,57,57,0,0,1,18.85-11.63,45.88,45.88,0,0,1-5-27.2,46.56,46.56,0,0,1,10-23.05A52.14,52.14,0,0,1,289,124.62a56.88,56.88,0,0,1,31.39-2.13c27.57,5.63,41.35,29.92,43.59,34l-75.1,152.27Z"
        transform="translate(-125.52 -29.4)"
      />
      <path
        class="cls-15"
        d="M304.07,295.75c-4.66-4.52-15.8-14-32.37-16.43a54.9,54.9,0,0,0-16.68.12,35.2,35.2,0,0,0-13,13.23c-7.61,13.76-3.07,28-2.23,30.47a37.35,37.35,0,0,0,9.43,17,36.48,36.48,0,0,0,19,10.29A43.74,43.74,0,0,0,290.52,344c13.61-8.4,18-21.73,19-25.29"
        transform="translate(-125.52 -29.4)"
      />
      <path
        class="cls-16"
        d="M304.07,295.75a65,65,0,0,0-5.32-4.06A63.22,63.22,0,0,0,281,283a54.69,54.69,0,0,0-25.65-1.42l.77-.28a34.64,34.64,0,0,0-8.74,7.74,31.23,31.23,0,0,0-5.41,10.2,34.45,34.45,0,0,0-1.61,11.48,40.69,40.69,0,0,0,2,11.51l0,.14,0,.07a34.65,34.65,0,0,0,9.43,16.61,31.47,31.47,0,0,0,3.66,3.15,31.14,31.14,0,0,0,4.09,2.61,35,35,0,0,0,9.1,3.38l-.47,0a42.9,42.9,0,0,0,13.1-1.92,41.43,41.43,0,0,0,11.95-5.92,43.72,43.72,0,0,0,5.19-4.34,47.28,47.28,0,0,0,8.18-10.94,46.32,46.32,0,0,0,2.9-6.32,44.79,44.79,0,0,1-5.23,13,43,43,0,0,1-21.75,18.1,46.88,46.88,0,0,1-14.27,2.83h-.19l-.28-.05a38.38,38.38,0,0,1-10.48-3.5,37.14,37.14,0,0,1-4.78-2.84,36.49,36.49,0,0,1-4.33-3.51,38.85,38.85,0,0,1-6.89-8.74,41.09,41.09,0,0,1-4.2-10.3l.07.21a38.93,38.93,0,0,1-1.6-6.49,43.47,43.47,0,0,1-.6-6.64,39.52,39.52,0,0,1,2-13.23,36.56,36.56,0,0,1,16.88-20.1l.41-.23.36-.05a58,58,0,0,1,13.87-.18,56,56,0,0,1,13.37,3.31,57.24,57.24,0,0,1,12,6.43A58.63,58.63,0,0,1,304.07,295.75Z"
        transform="translate(-125.52 -29.4)"
      />
      <path
        class="cls-17"
        d="M299.58,314.6c-.84-1.19-8.71-12.23-21.27-16.62-10.91-3.82-17.22.24-18.24.93-.69.62-9.57,9-3,25.32C264,341.29,293.79,326.84,299.58,314.6Z"
        transform="translate(-125.52 -29.4)"
      />
      <path
        class="cls-15"
        d="M552,312.23c2.65,5.93,9.44,18.88,23.91,27.33a54.8,54.8,0,0,0,15.51,6.11,35.17,35.17,0,0,0,17-7.42c12.2-9.92,13.3-24.82,13.45-27.43a37.38,37.38,0,0,0-2.4-19.31,36.48,36.48,0,0,0-13.82-16.66,43.66,43.66,0,0,0-23-2.36c-15.76,2.71-24.8,13.44-27.1,16.35"
        transform="translate(-125.52 -29.4)"
      />
      <path
        class="cls-16"
        d="M552,312.23q1.57,3,3.42,5.75a61.51,61.51,0,0,0,3.92,5.37,58.72,58.72,0,0,0,9.3,9.28,52.74,52.74,0,0,0,11,6.85,53.75,53.75,0,0,0,12.24,4l-.82,0a34.83,34.83,0,0,0,11-3.91,31.51,31.51,0,0,0,8.83-7.45,34.42,34.42,0,0,0,5.78-10.05,41.27,41.27,0,0,0,2.46-11.42v-.22a34.69,34.69,0,0,0-2.55-18.92,31.61,31.61,0,0,0-2.21-4.29,33.32,33.32,0,0,0-2.82-4,35.37,35.37,0,0,0-7.18-6.53l.41.21a42.62,42.62,0,0,0-12.86-3.11,41.51,41.51,0,0,0-13.31,1A43.72,43.72,0,0,0,572.2,277a46.87,46.87,0,0,0-6.07,3.1,47.66,47.66,0,0,0-5.61,4,46.37,46.37,0,0,0-5,4.77,44.93,44.93,0,0,1,9.72-10.14A43,43,0,0,1,592.13,270a46.65,46.65,0,0,1,14.29,2.7l.18.06.24.16a38,38,0,0,1,8.42,7.16,36.3,36.3,0,0,1,3.37,4.42,37.32,37.32,0,0,1,2.71,4.87,39,39,0,0,1,3.13,10.67,40.67,40.67,0,0,1,0,11.13l0-.22a39.4,39.4,0,0,1-.95,6.62,43,43,0,0,1-1.93,6.38,39.24,39.24,0,0,1-6.79,11.52,36.61,36.61,0,0,1-23.17,12.35l-.46.06-.35-.09a57.92,57.92,0,0,1-12.94-5,55.76,55.76,0,0,1-11.17-8.07A57.42,57.42,0,0,1,558,324.29,59.45,59.45,0,0,1,552,312.23Z"
        transform="translate(-125.52 -29.4)"
      />
      <path
        class="cls-17"
        d="M561.61,298.16c.46,1.38,4.82,14.22,15.58,22,9.35,6.8,16.56,4.73,17.74,4.36.83-.39,11.75-5.87,10.13-23.39C603.37,282.85,570.68,288.11,561.61,298.16Z"
        transform="translate(-125.52 -29.4)"
      />
      <ellipse class="cls-18" cx="303.7" cy="243.41" rx="148.38" ry="166.52" />
      <path
        class="cls-19"
        d="M392.43,352.11c-1.74,2.21-3.61,4.3-5.47,6.39s-3.79,4.1-5.75,6.09-3.91,4-5.91,5.91-4,3.85-6.07,5.74l.48-2.36q1.76,3.84,3.41,7.73c1.09,2.59,2.18,5.19,3.18,7.82s2,5.28,3,7.94,1.83,5.35,2.58,8.1c-1.59-2.37-3-4.82-4.43-7.26s-2.74-4.94-4-7.44-2.57-5-3.81-7.55-2.42-5.08-3.59-7.64l-.62-1.36,1.1-1c2.06-1.88,4.12-3.75,6.22-5.58s4.22-3.64,6.39-5.39,4.34-3.51,6.55-5.22S390.07,353.66,392.43,352.11Z"
        transform="translate(-125.52 -29.4)"
      />
      <ellipse class="cls-20" cx="369.03" cy="245.95" rx="30.41" ry="43.88" />
      <ellipse class="cls-21" cx="370.49" cy="246.17" rx="19.53" ry="32.03" />
      <ellipse class="cls-20" cx="365.47" cy="232.25" rx="11.82" ry="13.43" />
      <path
        class="cls-22"
        d="M467.23,256.08a24.94,24.94,0,0,1,2-10,28.4,28.4,0,0,1,5.81-8.78,30.23,30.23,0,0,1,8.73-6.25,31.58,31.58,0,0,1,10.42-2.88l.2,0h.16a27.84,27.84,0,0,1,9.93,2,26.12,26.12,0,0,1,8.46,5.42,25.72,25.72,0,0,1,3.24,3.77,26.31,26.31,0,0,1,2.39,4.26,23.38,23.38,0,0,1,2,9.22,38.84,38.84,0,0,0-4.75-7.59,36.26,36.26,0,0,0-2.91-3.13,29.28,29.28,0,0,0-3.26-2.58,26.38,26.38,0,0,0-7.29-3.52,28.4,28.4,0,0,0-7.91-1.2h.36a32.48,32.48,0,0,0-16.25,6.49,34.52,34.52,0,0,0-6.47,6.48A42.46,42.46,0,0,0,467.23,256.08Z"
        transform="translate(-125.52 -29.4)"
      />
      <ellipse class="cls-20" cx="230.38" cy="249.09" rx="30.41" ry="43.88" />
      <ellipse class="cls-21" cx="231.84" cy="249.3" rx="19.53" ry="32.03" />
      <ellipse class="cls-20" cx="226.83" cy="235.39" rx="11.82" ry="13.43" />
      <path
        class="cls-22"
        d="M328.58,259.22a24.94,24.94,0,0,1,2-10,28.4,28.4,0,0,1,5.81-8.78,30.46,30.46,0,0,1,8.73-6.26,31.55,31.55,0,0,1,10.43-2.87l.19,0h.17a28.27,28.27,0,0,1,9.92,2,26.21,26.21,0,0,1,8.46,5.43,25.21,25.21,0,0,1,3.24,3.77,26.31,26.31,0,0,1,2.39,4.26,23.37,23.37,0,0,1,2,9.21,39.05,39.05,0,0,0-4.75-7.58,33.45,33.45,0,0,0-2.91-3.13,27.34,27.34,0,0,0-3.26-2.58,26.38,26.38,0,0,0-7.29-3.52,28.4,28.4,0,0,0-7.91-1.2l.36,0a32.45,32.45,0,0,0-8.52,2.12,32.93,32.93,0,0,0-7.73,4.38,34.18,34.18,0,0,0-6.46,6.48A42,42,0,0,0,328.58,259.22Z"
        transform="translate(-125.52 -29.4)"
      />
      <path
        class="cls-23"
        d="M380.21,186.1c-.54-2.88-1.77-6.7-5-8.9-5.18-3.57-10.67.45-25.47,3.46-15.5,3.15-20.65,1-27.15,6.49a24.68,24.68,0,0,0-6.9,9.84,122,122,0,0,0,64.49-10.89Z"
        transform="translate(-125.52 -29.4)"
      />
      <path
        class="cls-23"
        d="M468.19,183.52c1-3.26,3.06-7.71,7.3-10.23,2.56-1.52,6.6-2.75,26.88,3.55,19,5.9,22.57,9.2,24.55,11.4a31.43,31.43,0,0,1,6.88,13.18,229.71,229.71,0,0,0-65.61-17.9Z"
        transform="translate(-125.52 -29.4)"
      />
      <path
        class="cls-24"
        d="M548.61,234.87h0a28.62,28.62,0,0,0-.34-3.3c-1.95-12.13-11.17-20.59-21.42-20.42l-71.72,1.18c-7.3,0-10.78,3.28-11.89,8.08a4.69,4.69,0,0,1-4.4,3.87H409.59a4.61,4.61,0,0,1-4.26-4c-.94-4.54-4-8-11.94-8l-71.71-1.18c-10.26-.17-19.49,8.29-21.43,20.43a28.45,28.45,0,0,0-.34,3.29h0a359.09,359.09,0,0,0,3.86,70.23l1.37,8.85c1.62,10.49,9.21,18.09,18.06,18.09h64c6.51,0,12.12-5.54,13.41-13.24,2.87-17.27,6.75-27.55,8.56-49.83.52-6.45-.38-20.14,14.51-20.14,14.15,0,15.05,12.63,15.7,19.43a322.81,322.81,0,0,0,8.46,49.59c1.91,7.89,6.74,14.19,13.57,14.19h64c8.85,0,16.45-7.6,18.07-18.09l1.36-8.85A358.31,358.31,0,0,0,548.61,234.87ZM390.34,308c-1.89,7.73-6.31,14-12.7,14H320.71c-3.61,0-6.7-3.26-7.36-7.75l-1.25-8.47c-3.77-25.63-5.14-43.86-4.06-69.9l.13-3.38q0-.6.12-1.26c.81-6.09,5.34-10.68,10.55-10.68L392,221.76c3.51.56,6.23,4.13,6.52,8.63C399.37,243.7,396.08,284.43,390.34,308Zm146-2.25-1.25,8.47c-.66,4.49-3.75,7.75-7.36,7.75H470.84c-6.39,0-11-6.16-12.69-14-4-18.66-9-64.27-8.17-77.58.29-4.5,3-8.07,6.52-8.63l73.15-1.26c5.2,0,9.74,4.59,10.55,10.68,0,.44.09.86.11,1.26l.14,3.38C541.52,261.86,540.15,280.09,536.38,305.72Z"
        transform="translate(-125.52 -29.4)"
      />
      <path
        class="cls-19"
        d="M388.81,176.59a171.43,171.43,0,0,0,18.14,6,107.28,107.28,0,0,0,18.27,3.21l2.3.2c.77.06,1.54.06,2.31.11,1.54.12,3.08.07,4.63.12,3.09,0,6.19-.13,9.31-.36a174.09,174.09,0,0,0,18.94-2.66,53.06,53.06,0,0,1-18.13,7.83,64.45,64.45,0,0,1-9.9,1.49,66.11,66.11,0,0,1-10.05-.11,62.59,62.59,0,0,1-19.4-4.91A53,53,0,0,1,388.81,176.59Z"
        transform="translate(-125.52 -29.4)"
      />
      <path
        class="cls-19"
        d="M394.27,155.14a93.86,93.86,0,0,0,15.94,7.29,65.8,65.8,0,0,0,16.43,3.41,63,63,0,0,0,8.36.1c1.4,0,2.78-.23,4.19-.32s2.81-.35,4.2-.61a98.59,98.59,0,0,0,16.92-4.62,39.88,39.88,0,0,1-15.59,9.68,43.67,43.67,0,0,1-9.15,2.15,46.45,46.45,0,0,1-4.71.37c-.79.06-1.58,0-2.37,0s-1.59,0-2.37-.1a48.81,48.81,0,0,1-9.3-1.7,44.69,44.69,0,0,1-8.7-3.57A39.66,39.66,0,0,1,394.27,155.14Z"
        transform="translate(-125.52 -29.4)"
      />
      <path
        class="cls-19"
        d="M468,352.29c1.72,1.77,3.35,3.6,5,5.46s3.18,3.73,4.71,5.63,3.07,3.81,4.54,5.76,3,3.88,4.41,5.85l.57.78-.32.94c-1,2.93-2,5.84-3,8.74s-2.17,5.77-3.27,8.66-2.32,5.72-3.57,8.55-2.53,5.65-4,8.41c.56-3.07,1.3-6.07,2.05-9.07s1.61-6,2.47-8.94,1.78-5.91,2.75-8.83,2-5.85,3-8.75l.25,1.72q-2.1-3-4.12-6.06c-1.37-2-2.69-4.08-4-6.14s-2.58-4.16-3.82-6.27S469.08,354.48,468,352.29Z"
        transform="translate(-125.52 -29.4)"
      />
      <path
        class="cls-16"
        d="M408.37,345.78a28,28,0,0,1,1.23-7,20,20,0,0,1,3.41-6.57,13.42,13.42,0,0,1,2.92-2.74,12.4,12.4,0,0,1,1.82-1,15.43,15.43,0,0,1,1.88-.72,23.24,23.24,0,0,1,7.52-.89,27.4,27.4,0,0,1,7.37.94,15.34,15.34,0,0,1,3.7,1.64,13.69,13.69,0,0,1,3,2.65,18,18,0,0,1,3.47,6.63,22.47,22.47,0,0,1,.91,7.06,55.22,55.22,0,0,0-3.25-6,20.56,20.56,0,0,0-4-4.78c-3-2.55-6.81-2.79-11.33-2.89a25.93,25.93,0,0,0-6.13.37c-.47.09-.94.23-1.38.36a8.3,8.3,0,0,0-1.24.51,10.62,10.62,0,0,0-2.36,1.63,23.84,23.84,0,0,0-4.09,4.88C410.57,341.7,409.52,343.73,408.37,345.78Z"
        transform="translate(-125.52 -29.4)"
      />
      <path
        class="cls-25"
        d="M469.93,378.83a36.85,36.85,0,0,0-9.49-11.5c-9-7.15-18.78-7.65-32.28-8.16-15.78-.58-27.48-1-36.14,7.22A28.89,28.89,0,0,0,384.47,379a153.35,153.35,0,0,0,85.46-.21Z"
        transform="translate(-125.52 -29.4)"
      />
      <path
        class="cls-16"
        d="M392.79,382c5.91,1.24,11.49,2.46,17.09,3.2a118.86,118.86,0,0,0,16.68,1.13c1.39,0,2.78,0,4.16-.11s2.77-.15,4.16-.23c2.78-.22,5.55-.55,8.35-.93,5.6-.79,11.18-2,17.09-3.29a45.59,45.59,0,0,1-15.68,9,57.21,57.21,0,0,1-8.88,2.26,62.58,62.58,0,0,1-9.17.78,56.42,56.42,0,0,1-18.07-2.91A45.57,45.57,0,0,1,392.79,382Z"
        transform="translate(-125.52 -29.4)"
      />
      <circle class="cls-26" cx="298.37" cy="579.32" r="12.44" />
      <circle class="cls-26" cx="298.37" cy="516.06" r="12.44" />
      <circle class="cls-26" cx="298.37" cy="692.7" r="12.44" />
      <circle class="cls-26" cx="298.37" cy="645.07" r="12.44" />
      <g class="cls-27">
        <line class="cls-28" x1="401.72" y1="731.74" x2="401.63" y2="734.53" />
        <line class="cls-29" x1="401.38" y1="742.92" x2="391.85" y2="1060.16" />
        <line class="cls-28" x1="391.72" y1="1064.35" x2="391.64" y2="1067.14" />
      </g>
      <path
        class="cls-30"
        d="M533.7,739.48a51.81,51.81,0,0,0-19.54,13.39,48.08,48.08,0,0,0-7,10.25,42.62,42.62,0,0,0-1.93,25.48,44,44,0,0,0,9.41,18.31,48.67,48.67,0,0,0,27.69,17.27,49.88,49.88,0,0,0,32-3.7c2.79-4.3,3-7.53,2.59-9.72-1.06-6.11-7.29-8.52-7.38-14.49a10.48,10.48,0,0,1,1.92-5.9,27.67,27.67,0,0,0,5-34.62,79.87,79.87,0,0,1-21.77-4.64A77.17,77.17,0,0,1,533.7,739.48Z"
        transform="translate(-125.52 -29.4)"
      />
      <path
        class="cls-31"
        d="M569.48,388.72a73.35,73.35,0,0,1,31.06,17.95c10.26,10.18,14.79,21.88,17.22,27.92,1.54,3.84,13.81,39.3,16.81,47.67,13.71,38.25,11.82,80.6,11.06,97.66-.21,4.89-.48,8.41-.56,9.48-1,12.27-3.82,38.56-18.82,81a529.71,529.71,0,0,1-38.17,83.73,84.91,84.91,0,0,1-33.34-3.93,79.5,79.5,0,0,1-23.84-12.57,669.91,669.91,0,0,1,26.5-101c6.54-18.82,13.57-36.31,20.75-52.46-9.19-33.51-16.66-59-20.47-71.72-9.72-32.37-11.36-30-13.66-42.33-4.86-26,.6-44.45.6-44.45C550.29,406.85,562.55,394.62,569.48,388.72Z"
        transform="translate(-125.52 -29.4)"
      />
      <path
        class="cls-12"
        d="M536.94,508.8v14.61a184.76,184.76,0,0,1-62.48,0V508.8c9.32.85,19.49,1.4,30.39,1.42C516.4,510.25,527.14,509.69,536.94,508.8Z"
        transform="translate(-125.52 -29.4)"
      />
      <path
        class="cls-10"
        d="M158.69,1150.92a1.67,1.67,0,0,1-1.25,1.62,42,42,0,0,1-9.6,1.35,42.44,42.44,0,0,1-11.64-1.35,1.67,1.67,0,0,1-1.24-1.62v-15.2a1.67,1.67,0,0,1,2-1.63,42.27,42.27,0,0,0,19.63,0,1.67,1.67,0,0,1,2.05,1.63Z"
        transform="translate(-125.52 -29.4)"
      />
      <path
        class="cls-12"
        d="M376.52,675v14.61a184.82,184.82,0,0,1-62.49,0V675c9.33.85,19.5,1.39,30.4,1.42C356,676.41,366.72,675.85,376.52,675Z"
        transform="translate(-125.52 -29.4)"
      />
      <path
        class="cls-12"
        d="M530.9,674.48v14.61a184.76,184.76,0,0,1-62.48,0V674.48c9.33.85,19.49,1.39,30.39,1.42C510.36,675.93,521.1,675.37,530.9,674.48Z"
        transform="translate(-125.52 -29.4)"
      />
      <path
        class="cls-32"
        d="M598.66,110.4c-6.82-8.59-28.2-22.92-37.79-28.18-26-14.24-53.59-28.64-83.53-34.93-50.65-10.64-90.63-.89-116.1,5.27-9.58,2.32-41.78,10.6-73.11,33.9-21.45,16-24.29,25.42-23.46,31.75,1,7.6,7.63,12.48,14.33,17.71,18.36,14.34,38.47,17.23,43.16,17.85C369,159.92,387.48,141.11,436,143.13c26.19,1.08,30.3,7,90.86,13,16.5,1.65,32.27,2.81,47.49-6.33C587.57,141.84,608.14,122.33,598.66,110.4Z"
        transform="translate(-125.52 -29.4)"
      />
      <ellipse class="cls-33" cx="308.91" cy="11.21" rx="21.89" ry="11.21" />
    </svg>

    <svg
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 493.86 1099.24"
      class="boy panda-carector pc-2"
    >
      <defs></defs>
      <path
        class="cls-1"
        d="M385.2,1071.78a57.59,57.59,0,0,1,4.77,18.71c.51,6.45,1.06,13.43-2.39,18.66-4.06,6.16-10.31,4.56-24.89,8.67-18.16,5.13-20.14,10.8-41.3,16.1a57.44,57.44,0,0,1-19,1.19c-5.26-.52-11-1.15-16.67-5.18-2.07-1.47-6.17-4.38-7.72-8.74-4.05-11.39,11.64-26,16.34-30.34,12.45-11.56,26.8-16.72,37.88-19.07Z"
        transform="translate(-179.41 -38.37)"
      />
      <path
        class="cls-1"
        d="M464,1071.78a57.36,57.36,0,0,0-4.76,18.71c-.51,6.45-1.07,13.43,2.38,18.66,4.06,6.16,10.31,4.56,24.9,8.67,18.15,5.13,20.13,10.8,41.29,16.1a57.44,57.44,0,0,0,19,1.19c5.26-.52,11-1.15,16.67-5.18,2.07-1.47,6.17-4.38,7.72-8.74,4-11.39-11.64-26-16.34-30.34-12.44-11.56-26.8-16.72-37.87-19.07Z"
        transform="translate(-179.41 -38.37)"
      />
      <path
        class="cls-2"
        d="M318,760.28l12.65,311.5a98.76,98.76,0,0,0,52.93,0l43.47-233.92,38,233.92a47.25,47.25,0,0,0,53,0q7.79-155.76,15.55-311.5Z"
        transform="translate(-179.41 -38.37)"
      />
      <path
        class="cls-3"
        d="M209.63,760.28a94.61,94.61,0,0,0-20.06,21c-2.67,3.83-6.83,9.65-7.47,13.66A27.14,27.14,0,0,0,186,813.85c5.74,8.84,23.35,14.33,28.33,15.12a43.26,43.26,0,0,0,11.48.25,3.36,3.36,0,0,0,2.68-4.78,31.75,31.75,0,0,1-1.68-22.59c2.73-8.41,4-10,4.68-9.85,1.62.29-.74,10.48,4.71,15.38l.07.06a5.37,5.37,0,0,0,8.67-2.92,44.63,44.63,0,0,0,1.21-8.69,47.62,47.62,0,0,0-8.15-28Z"
        transform="translate(-179.41 -38.37)"
      />
      <path
        class="cls-3"
        d="M638,743.55a94.37,94.37,0,0,1,22.61,18.19c3.15,3.45,8,8.67,9.18,12.57a27.18,27.18,0,0,1-1.38,19.28c-4.55,9.52-21.3,17.25-26.13,18.67A43,43,0,0,1,630.89,814a3.36,3.36,0,0,1-3.27-4.39A31.69,31.69,0,0,0,626.35,787c-3.8-8-5.27-9.36-5.91-9.15-1.57.49,2.09,10.29-2.68,15.86l-.06.07a5.37,5.37,0,0,1-9-1.77,44.84,44.84,0,0,1-2.32-8.47,47.63,47.63,0,0,1,4.44-28.78Z"
        transform="translate(-179.41 -38.37)"
      />
      <path
        class="cls-4"
        d="M339.5,486.75a71.91,71.91,0,0,0-28.92,18.15,67.51,67.51,0,0,0-11.1,15.69c-45.34,86.3-79.91,187.4-89.73,236.85a25.39,25.39,0,0,0,10.9,13.63,25.69,25.69,0,0,0,19.07,2.73C249.85,762.7,326,618.12,338.4,583.17A479.38,479.38,0,0,1,324.24,686.4a479.71,479.71,0,0,1-35,95.58,300.19,300.19,0,0,0,267.54,5.44,452.57,452.57,0,0,1-34.23-112.57,526.87,526.87,0,0,1-6.68-90.75c8.5,17.68,18.71,46.44,28.2,64.33,22.05,41.62,39.4,82,62.29,114.88a45.25,45.25,0,0,0,34-21.31c-36.93-85.91-62.6-149-73.28-185.86-3.39-11.71-11.59-42.6-38.72-64.4a98.56,98.56,0,0,0-16.09-10.51Z"
        transform="translate(-179.41 -38.37)"
      />
      <ellipse class="cls-5" cx="245.91" cy="466.36" rx="19.07" ry="17.99" />
      <path
        class="cls-6"
        d="M327.07,475.64a18.38,18.38,0,0,0-15.81,15,25.4,25.4,0,0,0,2.7,5.81c9,14.08,29.84,14.8,47,16.4a404.87,404.87,0,0,1,64.26,11.45,49.12,49.12,0,0,1-27-33.21c17-.47,31.82-3.94,48.82-4.41a34.93,34.93,0,0,1,.73,10.43,32.49,32.49,0,0,1-6.12,15.15c-6.13,8.64-13.46,11.36-12.95,12.41.68,1.44,14-4.75,28.81-8.5,13.79-3.47,13.75-2.82,42.48-4,11.47-.46,35.71-.13,51-16.47a43.22,43.22,0,0,0,3.53-4.31,28.16,28.16,0,0,0-24.85-22.58Z"
        transform="translate(-179.41 -38.37)"
      />
      <circle class="cls-3" cx="247.76" cy="287.27" r="178.54" />
      <path
        class="cls-7"
        d="M308.78,208.13c16.74,29.51,13.76,49.16,8.17,61.52-8.5,18.82-24.82,24.74-35.51,46.39-9.74,19.73-7.88,38.46-5.08,50.66-15-7.12-39.32-21.21-57-46.34-15.6-22.13-19.29-42.92-21.52-57.2-2.75-17.54-2.79-33.14,3.64-52.79a54.45,54.45,0,0,1,28.26-31.61,64.55,64.55,0,0,1,22-6,60,60,0,0,1-4.66-11.4,66.87,66.87,0,0,1-2.35-16.79c.06-12.61,6.41-31.09,21-47.74,13.16-15,28.05-22.83,41-29.51,44.34-22.88,88.38-25.54,106.65-26.08,46.79-1.39,82.84,10,103.7,16.6,20.37,6.42,22.58,9.23,38.93,13.82,38.13,10.71,73.26,8.7,97.48,5.15A212.4,212.4,0,0,1,588.85,126a212.5,212.5,0,0,1-82.93,21.45,242.64,242.64,0,0,0,60.18,8,241.93,241.93,0,0,0,59-6.89,287.28,287.28,0,0,1-57.61,44.08,289.32,289.32,0,0,1-116.07,37.53A291.5,291.5,0,0,1,308.78,208.13Z"
        transform="translate(-179.41 -38.37)"
      />
      <path
        class="cls-8"
        d="M457.08,392.25a15.3,15.3,0,0,1,14.78-.47,16.74,16.74,0,0,1,3.46,2.2,17.35,17.35,0,0,1,2.89,3,19.69,19.69,0,0,1,2.17,3.53c.3.62.56,1.27.8,1.92s.42,1.38.57,2a17.71,17.71,0,0,1,0,8.47,15.5,15.5,0,0,1-1.6,4,17.66,17.66,0,0,1-1.16,1.79c-.45.54-.9,1.08-1.39,1.57a14.83,14.83,0,0,1-14.29,4c4.31-2.17,7.46-5,9.15-8.11a13.33,13.33,0,0,0,1.16-9.77,17.3,17.3,0,0,0-5.28-9.05C465.64,394.8,461.83,393.09,457.08,392.25Z"
        transform="translate(-179.41 -38.37)"
      />
      <path
        class="cls-8"
        d="M399.42,438.24a52.31,52.31,0,0,0,7.35,14.62A30.6,30.6,0,0,0,418,462.21a35,35,0,0,0,14.45,3.41,52.69,52.69,0,0,0,16.21-2.35,26.84,26.84,0,0,1-15.61,8.89,29.82,29.82,0,0,1-18.71-2.44c-.74-.33-1.43-.77-2.13-1.17a25.83,25.83,0,0,1-4-2.85,23.32,23.32,0,0,1-1.79-1.65l-1.63-1.8c-.5-.64-1-1.3-1.43-1.95a27.75,27.75,0,0,1-4-22.06Z"
        transform="translate(-179.41 -38.37)"
      />
      <ellipse class="cls-9" cx="354.31" cy="295.45" rx="36.59" ry="52.8" />
      <ellipse class="cls-10" cx="356.07" cy="295.7" rx="23.5" ry="38.55" />
      <ellipse class="cls-9" cx="350.03" cy="278.96" rx="14.22" ry="16.16" />
      <path
        class="cls-11"
        d="M500.85,310.62a27.19,27.19,0,0,1,.59-6.08,31.15,31.15,0,0,1,1.85-5.94,34.7,34.7,0,0,1,3-5.57,35.87,35.87,0,0,1,14.52-12.52,38.12,38.12,0,0,1,12.55-3.46l.23,0h.2a33.91,33.91,0,0,1,12,2.37,31.59,31.59,0,0,1,10.18,6.53,31,31,0,0,1,3.89,4.54,31.92,31.92,0,0,1,2.88,5.12,29.53,29.53,0,0,1,1.8,5.48,24.9,24.9,0,0,1,.65,5.61,51.52,51.52,0,0,0-2.64-4.81,49.18,49.18,0,0,0-3.07-4.32,41.92,41.92,0,0,0-3.51-3.76,33.84,33.84,0,0,0-3.92-3.11,32.27,32.27,0,0,0-8.77-4.23,33.84,33.84,0,0,0-9.52-1.44l.43,0a39.33,39.33,0,0,0-19.55,7.81,40.25,40.25,0,0,0-7.77,7.8,46.46,46.46,0,0,0-3.21,4.75c-.5.84-1,1.69-1.42,2.58S501.28,309.7,500.85,310.62Z"
        transform="translate(-179.41 -38.37)"
      />
      <ellipse class="cls-9" cx="200.58" cy="299.23" rx="36.59" ry="52.8" />
      <ellipse class="cls-10" cx="202.33" cy="299.48" rx="23.5" ry="38.55" />
      <ellipse class="cls-9" cx="196.3" cy="282.74" rx="14.22" ry="16.16" />
      <path
        class="cls-11"
        d="M347.11,314.4a27.81,27.81,0,0,1,.6-6.08,31.61,31.61,0,0,1,1.84-5.94,35.23,35.23,0,0,1,3-5.58,36,36,0,0,1,14.52-12.51,37.81,37.81,0,0,1,12.55-3.46l.23,0h.2a33.91,33.91,0,0,1,12,2.37,31.59,31.59,0,0,1,10.18,6.53,30.94,30.94,0,0,1,3.89,4.53,32.45,32.45,0,0,1,2.88,5.13,29.39,29.39,0,0,1,1.79,5.47,24.38,24.38,0,0,1,.66,5.62,49.1,49.1,0,0,0-2.64-4.81,45.91,45.91,0,0,0-3.08-4.32,42,42,0,0,0-3.5-3.77,33.75,33.75,0,0,0-3.92-3.1,32,32,0,0,0-8.77-4.24,34.21,34.21,0,0,0-9.52-1.44l.43,0a39,39,0,0,0-10.25,2.55,39.65,39.65,0,0,0-9.3,5.26,41.11,41.11,0,0,0-7.78,7.81,48.72,48.72,0,0,0-3.21,4.75c-.49.84-1,1.69-1.41,2.57S347.55,313.48,347.11,314.4Z"
        transform="translate(-179.41 -38.37)"
      />
      <path
        class="cls-8"
        d="M373.77,236.83a61.42,61.42,0,0,0-15.83,4,32.23,32.23,0,0,0-11.36,8.06,37.19,37.19,0,0,0-7.26,12.19c-1.84,4.7-2.73,9.9-3.37,16a25.39,25.39,0,0,1-5.23-17.68,29.3,29.3,0,0,1,15.62-24.18c.76-.37,1.53-.73,2.29-1.07s1.59-.55,2.38-.82a27.57,27.57,0,0,1,14.38-.39,25.74,25.74,0,0,1,4.41,1.5A18.46,18.46,0,0,1,373.77,236.83Z"
        transform="translate(-179.41 -38.37)"
      />
      <path
        class="cls-8"
        d="M560.78,252.77a61.08,61.08,0,0,0-13.33-9.45,32.36,32.36,0,0,0-13.5-3.43,37.51,37.51,0,0,0-14,2.36c-4.77,1.66-9.31,4.35-14.38,7.82a25.49,25.49,0,0,1,10.08-15.45,29.53,29.53,0,0,1,18.65-5.86,29.17,29.17,0,0,1,9.89,2.1c.77.34,1.54.69,2.3,1s1.45.86,2.16,1.29a26.46,26.46,0,0,1,3.91,3.05,27.57,27.57,0,0,1,5.71,7.64,25,25,0,0,1,1.71,4.33A19,19,0,0,1,560.78,252.77Z"
        transform="translate(-179.41 -38.37)"
      />
      <ellipse class="cls-12" cx="198.43" cy="300.46" rx="70.75" ry="76.79" />
      <ellipse class="cls-13" cx="363.81" cy="297.21" rx="64.01" ry="76.79" />
      <line class="cls-14" x1="273.69" y1="298.35" x2="295.67" y2="298.35" />
      <path
        class="cls-5"
        d="M286.21,359.57c-4.23-5-14.45-15.52-30.78-19.56a55.44,55.44,0,0,0-16.68-1.5,35.4,35.4,0,0,0-14.28,12c-8.95,13-5.79,27.69-5.19,30.25a37.59,37.59,0,0,0,7.78,17.94,36.77,36.77,0,0,0,18,12.14A44,44,0,0,0,268,406.54c14.42-7.08,20.09-20,21.48-23.43"
        transform="translate(-179.41 -38.37)"
      />
      <path
        class="cls-8"
        d="M286.21,359.57c-1.57-1.61-3.22-3.13-4.93-4.57a60.93,60.93,0,0,0-5.29-4.07,58.78,58.78,0,0,0-11.6-6.3,52.77,52.77,0,0,0-12.57-3.48,53.92,53.92,0,0,0-12.94-.43l.8-.2a34.68,34.68,0,0,0-9.49,6.89,31.24,31.24,0,0,0-6.39,9.68,34.27,34.27,0,0,0-2.73,11.32,41.35,41.35,0,0,0,.86,11.7l0,.14v.07a34.81,34.81,0,0,0,7.82,17.52,32.65,32.65,0,0,0,3.35,3.51,31.93,31.93,0,0,0,3.84,3,35.25,35.25,0,0,0,8.77,4.26l-.46-.08a43,43,0,0,0,13.28-.65,41.32,41.32,0,0,0,12.52-4.76,45.17,45.17,0,0,0,5.61-3.83,48.11,48.11,0,0,0,5-4.72,49.9,49.9,0,0,0,7.78-11.46A44.82,44.82,0,0,1,283,395.63a43.07,43.07,0,0,1-23.5,16,47.13,47.13,0,0,1-14.55,1.45l-.18,0-.28-.07a38.12,38.12,0,0,1-10.14-4.52,38.57,38.57,0,0,1-8.49-7.23,38.77,38.77,0,0,1-6-9.4,41.21,41.21,0,0,1-3.2-10.71l0,.22a39,39,0,0,1-1-6.65,44.08,44.08,0,0,1,.06-6.7A39.8,39.8,0,0,1,219,355a36.84,36.84,0,0,1,18.83-18.46l.43-.18.36,0a57.22,57.22,0,0,1,13.89,1.17,55.8,55.8,0,0,1,13.05,4.61A57.06,57.06,0,0,1,277,349.67,59.33,59.33,0,0,1,286.21,359.57Z"
        transform="translate(-179.41 -38.37)"
      />
      <path
        class="cls-6"
        d="M502.74,765.4a197.34,197.34,0,0,1-149.38,0,119.45,119.45,0,0,0,27.92-56.55,235.75,235.75,0,0,0,90.58.07,146,146,0,0,0,30.88,56.48Z"
        transform="translate(-179.41 -38.37)"
      />
      <path
        class="cls-15"
        d="M412.62,572.81a190.32,190.32,0,0,0,7.12-26.23,168.06,168.06,0,0,0,2.89-20.89"
        transform="translate(-179.41 -38.37)"
      />
      <path
        class="cls-16"
        d="M412.62,572.81a190.32,190.32,0,0,0,7.12-26.23,168.06,168.06,0,0,0,2.89-20.89"
        transform="translate(-179.41 -38.37)"
      />
      <path
        class="cls-17"
        d="M419.23,575.12a7,7,0,1,1-4.3-8.93A7,7,0,0,1,419.23,575.12Z"
        transform="translate(-179.41 -38.37)"
      />
      <path
        class="cls-15"
        d="M439.71,577.6a179.59,179.59,0,0,0-2.38-29.49,157.78,157.78,0,0,0-5.19-22.42"
        transform="translate(-179.41 -38.37)"
      />
      <path
        class="cls-18"
        d="M439.71,577.6a179.59,179.59,0,0,0-2.38-29.49,157.78,157.78,0,0,0-5.19-22.42"
        transform="translate(-179.41 -38.37)"
      />
      <path
        class="cls-17"
        d="M446.59,577.61a6.88,6.88,0,1,1-6.87-6.89A6.88,6.88,0,0,1,446.59,577.61Z"
        transform="translate(-179.41 -38.37)"
      />
      <path
        class="cls-8"
        d="M188.27,799a63.15,63.15,0,0,0,5.14,22.53,2.52,2.52,0,0,0,3.42.9,2.57,2.57,0,0,0,.9-3.42,56.26,56.26,0,0,1-4.46-20c-.12-3.2-5.12-3.22-5,0Z"
        transform="translate(-179.41 -38.37)"
      />
      <path
        class="cls-8"
        d="M197,801.7c4.07,8.1,3.48,17.64,6.78,26a2.59,2.59,0,0,0,3.08,1.75,2.52,2.52,0,0,0,1.74-3.08c-3.47-8.81-3-18.64-7.28-27.2-1.45-2.88-5.76-.35-4.32,2.52Z"
        transform="translate(-179.41 -38.37)"
      />
      <path
        class="cls-8"
        d="M210.61,805.5a81.07,81.07,0,0,0,1.07,15.24c.55,3.37,1.24,11.27,6.34,10.68a2.58,2.58,0,0,0,2.5-2.5,2.51,2.51,0,0,0-2.5-2.5c-.45,0-.37.07.23.18l-.13-.14-.25-.53a17.65,17.65,0,0,1-.56-2.33c-.43-1.94-.79-3.9-1.07-5.86a74.79,74.79,0,0,1-.63-12.24c.08-3.22-4.92-3.22-5,0Z"
        transform="translate(-179.41 -38.37)"
      />
      <path
        class="cls-8"
        d="M634.19,783.19a46.37,46.37,0,0,1,.31,25.51c-.85,3.11,4,4.43,4.82,1.33a51.37,51.37,0,0,0-.31-28.17c-.92-3.08-5.75-1.77-4.82,1.33Z"
        transform="translate(-179.41 -38.37)"
      />
      <path
        class="cls-8"
        d="M642.81,781.61c5.46,8.07,3.51,18.18,1.7,27.09a2.58,2.58,0,0,0,1.75,3.08,2.53,2.53,0,0,0,3.08-1.75c2.07-10.2,4-21.72-2.21-30.95-1.79-2.65-6.13-.15-4.32,2.53Z"
        transform="translate(-179.41 -38.37)"
      />
      <path
        class="cls-8"
        d="M654.91,781.06a23.5,23.5,0,0,1,1.57,19.39,2.53,2.53,0,0,0,1.75,3.07,2.56,2.56,0,0,0,3.08-1.74,28.5,28.5,0,0,0-2.08-23.25c-1.58-2.8-5.9-.28-4.32,2.53Z"
        transform="translate(-179.41 -38.37)"
      />
    </svg>
  </div>
</template>

<script>
import { gsap, Back } from "gsap";

export default {
  mounted() {
    let tl = gsap.timeline();
    gsap.set(".main-panda-loading", {
      y: 10,
    });
    tl.from(".panda-carector", {
      ease: Back.easeIn.config(1.2),
      scale: 0.5,
      stagger: 0.8,
      opacity: 0,
      duration: 0.8,
    });
    tl.to(".panda-carector", {
      stagger: 0.5,
      scale: 0.5,
      opacity: 0,
      ease: Back.easeOut.config(1.7),
      duration: 0.8,
    });
    if (window.innerWidth >= 768)
      tl.to(".main-panda-loading", { x: -315, y: 30, scale: 1.12 }).to(".page-loading", {
        opacity: 0,
        duration: 1,
        visibility: "hidden",
      });
    else {
      tl.to(".main-panda-loading", { x: 0, y: 50, scale: 3 }).to(".page-loading", {
        opacity: 0,
        duration: 1,
        visibility: "hidden",
      });
    }
  },
};
</script>

<style lang="scss">
#panda-hand {
  transform-origin: "60% 50%";
}

.grand {
  .cls-1,
  .cls-28,
  .cls-29 {
    fill: none;
  }
  .cls-13,
  .cls-2,
  .cls-20,
  .cls-31,
  .cls-9 {
    fill: #fff;
  }
  .cls-2,
  .cls-31,
  .cls-9 {
    stroke: #48110f;
  }
  .cls-11,
  .cls-13,
  .cls-18,
  .cls-2,
  .cls-28,
  .cls-29,
  .cls-30,
  .cls-31,
  .cls-5,
  .cls-8,
  .cls-9 {
    stroke-miterlimit: 10;
  }
  .cls-2 {
    stroke-width: 7px;
  }
  .cls-3 {
    fill: #870f17;
  }
  .cls-4 {
    fill: #a81d26;
  }
  .cls-5 {
    fill: #a75534;
    stroke: #45211a;
    stroke-width: 3.48px;
  }
  .cls-6 {
    fill: #45211a;
  }
  .cls-7 {
    fill: #180600;
    opacity: 0.54;
  }
  .cls-15,
  .cls-18,
  .cls-30,
  .cls-8 {
    fill: #ffe8b6;
  }
  .cls-18,
  .cls-30,
  .cls-8 {
    stroke: #5e3b3a;
  }
  .cls-8 {
    stroke-width: 4.08px;
  }
  .cls-9 {
    stroke-width: 6.52px;
  }
  .cls-10 {
    fill: #21151a;
  }
  .cls-11,
  .cls-13 {
    stroke: #510d05;
  }
  .cls-11 {
    stroke-width: 4.3px;
    fill: url(#New_Pattern_Swatch_2);
  }
  .cls-12 {
    fill: #4e0600;
  }
  .cls-13 {
    stroke-width: 5.19px;
  }
  .cls-14,
  .cls-23,
  .cls-25 {
    fill: #e9e4e3;
    stroke: #636260;
  }
  .cls-14,
  .cls-23,
  .cls-25,
  .cls-28,
  .cls-29,
  .cls-32 {
    stroke-linecap: round;
  }
  .cls-14,
  .cls-23,
  .cls-25,
  .cls-32 {
    stroke-linejoin: round;
  }
  .cls-14 {
    stroke-width: 4.16px;
  }
  .cls-16 {
    fill: #5e3b3a;
  }
  .cls-17 {
    fill: #d7b686;
  }
  .cls-18 {
    stroke-width: 4.14px;
  }
  .cls-19 {
    fill: #d9c69d;
  }
  .cls-21 {
    fill: #191817;
  }
  .cls-22 {
    fill: #1d1d1b;
  }
  .cls-23 {
    stroke-width: 2.48px;
  }
  .cls-24 {
    fill: #1f2833;
  }
  .cls-25 {
    stroke-width: 3.65px;
  }
  .cls-26 {
    fill: #252321;
  }
  .cls-27 {
    opacity: 0.74;
  }
  .cls-28,
  .cls-29 {
    stroke: #575756;
    stroke-width: 1.86px;
  }
  .cls-29 {
    stroke-dasharray: 5.59 8.39;
  }
  .cls-30 {
    stroke-width: 4.25px;
  }
  .cls-31 {
    stroke-width: 6.51px;
  }
  .cls-32 {
    fill: #282826;
    stroke: #221c18;
    stroke-width: 7.13px;
  }
  .cls-33 {
    fill: #221c18;
  }
}
.robot {
  .cls-1 {
    fill: #867e7a;
  }
  .cls-2 {
    fill: #272d2f;
  }
  .cls-3 {
    fill: #b8b4b3;
  }
  .cls-4 {
    fill: #413d3a;
  }
  .cls-5 {
    fill: #66605d;
  }
  .cls-6,
  .cls-8 {
    fill: #fff;
  }
  .cls-7 {
    fill: #c0e2e0;
  }
  .cls-8 {
    opacity: 0.43;
  }
}
.girl-svg {
  .cls-1,
  .cls-7,
  .cls-8 {
    fill: #ffe8b6;
  }
  .cls-1 {
    stroke: #5e3b3a;
  }
  .cls-1,
  .cls-17,
  .cls-3,
  .cls-7,
  .cls-8 {
    stroke-miterlimit: 10;
  }
  .cls-1,
  .cls-7 {
    stroke-width: 1.27px;
  }
  .cls-11,
  .cls-12,
  .cls-13,
  .cls-2,
  .cls-6 {
    fill: #fff;
  }
  .cls-2,
  .cls-3 {
    stroke: #17100f;
  }
  .cls-10,
  .cls-11,
  .cls-12,
  .cls-2,
  .cls-5,
  .cls-6 {
    stroke-linecap: round;
    stroke-linejoin: round;
  }
  .cls-2 {
    stroke-width: 1.2px;
  }
  .cls-3 {
    fill: #3a302b;
    stroke-width: 1.2px;
  }
  .cls-4 {
    fill: #5e3b1e;
  }
  .cls-18,
  .cls-5 {
    fill: #9373ac;
  }
  .cls-11,
  .cls-12,
  .cls-5,
  .cls-6 {
    stroke: #262353;
  }
  .cls-5 {
    stroke-width: 1.63px;
  }
  .cls-6 {
    stroke-width: 1.07px;
  }
  .cls-7 {
    stroke: #252552;
  }
  .cls-10,
  .cls-8 {
    stroke: #5e3b1e;
  }
  .cls-8 {
    stroke-width: 1.22px;
  }
  .cls-9 {
    fill: #752825;
  }
  .cls-10 {
    fill: #bc731e;
    stroke-width: 1.65px;
  }
  .cls-11 {
    stroke-width: 0.96px;
  }
  .cls-12 {
    stroke-width: 0.97px;
  }
  .cls-14 {
    fill: #191817;
  }
  .cls-15 {
    fill: #1d1d1b;
  }
  .cls-16 {
    fill: #f08589;
  }
  .cls-17 {
    fill: none;
    stroke: #752825;
    stroke-width: 0.27px;
  }
  .cls-19 {
    fill: #5e3b3a;
  }
}
.boy {
  .cls-1 {
    fill: #51290d;
    stroke: #351f1c;
    stroke-width: 4.43px;
  }
  .cls-1,
  .cls-12,
  .cls-13,
  .cls-14,
  .cls-3 {
    stroke-miterlimit: 10;
  }
  .cls-2 {
    fill: #272154;
    stroke: #160d2e;
    stroke-width: 4.76px;
  }
  .cls-16,
  .cls-18,
  .cls-2,
  .cls-4,
  .cls-6,
  .cls-7 {
    stroke-linecap: round;
    stroke-linejoin: round;
  }
  .cls-3,
  .cls-5 {
    fill: #ffe8b6;
  }
  .cls-3,
  .cls-7 {
    stroke: #5e3b3a;
  }
  .cls-3 {
    stroke-width: 4.7px;
  }
  .cls-15,
  .cls-4,
  .cls-6 {
    fill: #69b1d5;
  }
  .cls-16,
  .cls-18,
  .cls-4,
  .cls-6 {
    stroke: #262353;
  }
  .cls-4 {
    stroke-width: 4px;
  }
  .cls-6 {
    stroke-width: 4.24px;
  }
  .cls-7 {
    fill: #944a28;
    stroke-width: 5.57px;
  }
  .cls-8 {
    fill: #5e3b3a;
  }
  .cls-9 {
    fill: #fff;
  }
  .cls-10 {
    fill: #191817;
  }
  .cls-11 {
    fill: #1d1d1b;
  }
  .cls-12,
  .cls-13,
  .cls-14,
  .cls-16,
  .cls-18 {
    fill: none;
  }
  .cls-12,
  .cls-13,
  .cls-14 {
    stroke: #c51a1b;
  }
  .cls-12 {
    stroke-width: 12.27px;
  }
  .cls-13 {
    stroke-width: 12.14px;
  }
  .cls-14 {
    stroke-width: 12.49px;
  }
  .cls-16 {
    stroke-width: 4.24px;
  }
  .cls-17 {
    fill: #262353;
  }
  .cls-18 {
    stroke-width: 4.95px;
  }
}
.page-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgb(255, 255, 255);
  background: radial-gradient(
    circle,
    rgba(255, 255, 255, 1) 0%,
    rgba(201, 201, 201, 1) 100%
  );
  height: 100vh;
  width: 100vw;
  position: fixed;
  z-index: 1000;
  top: 0;
  left: 0;
}

.panda-carector {
  min-height: 300px !important;
  margin: 0 2rem;
  @media (max-width: 768px) {
    margin: 0 0em;
  }
}
.main-panda-loading {
  @media (max-width: 768px) {
    margin: 0 0em;
    min-height: 250px !important;
    position: relative;
    top: 20px;
  }
}

.loading-logo {
  position: absolute;
  height: 200px;
  bottom: 20px;
  left: 0;
}
</style>
